import { alpha } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

const mixins = {
  content: {
    width: 1410,
    height: 1000,
  },
  aside: {
    width: 390,
  },
  hKioskHeader: {
    height: 110, // kiosk header
  },
  hKioskFooter: {
    height: 0, // kiosk footer
  },
  hKioskScreenSaver: {
    width: 1400,
    height: 1000,
  },
  kioskNavigation: {
    height: 240,
    width: "32dvw",
  },
  collapsedContent: {
    width: 1280,
  },
  expandedContent: {
    width: 520,
  },
  bottomNavigation: {
    height: 80,
  },
  mobileHeader: {
    height: 70,
  },
  mobileDirectionSearch: {
    width: 380,
  },
  // `aspectRatio` is used to set the aspect ratio of the event/promotion card
  cardRatio: {
    aspectRatio: "47/70",
  },
}

export const themeOptionFactory = (theme) => ({
  mixins: theme.mixins || mixins,
  assets: {
    /**
     * The icon configuration format for pages with no data.
     * Example:
     * promotions: {
     *   "icon_comp": "_COMPONENT_NAME_", // optional
     *   "icon_path": "_SVG_PATH_", // optional
     *   "icon_img": "_IMG_SRC_", // optional
     * }
     */
    empty: {
      promotions: {},
      events: {},
      dining: {},
      newShops: {},
      directory: {},
      touristPrivilege: {},
    },
    /**
     * The platform's application logo.
     */
    platforms: {
      hungryhub: {
        url: "https://s3.venue.in.th/A_Idro_l_Tu_L_kv_SBUZW_Yuq_ISO_Bx_Ve_W_Ud_O2_Pnbedds_R_Kghe_S_Cz_Q_s900_c_k_c0x00ffffff_no_rj_c0581c6d35.jpeg",
      },
      queq: {
        url: "https://s3.venue.in.th/y_L_bck_Ze_HH_0oj_DL_Yute_DVQ_Tqz_CY_9um_R2e_N4j0lg0xt0qsp_Z6_IGA_Bxjsd_U_Ng_YGB_94mw_dfc33a12b5.png",
      },
      "lineman-wongnai": {
        url: "https://s3.venue.in.th/xq_HA_S_Yn_WC_3_HYA_Qi1_J_Zg_MP_Fax_YX_2_WQ_Ly_twv44_YWC_9_Q_N_Xe_BUM_Avj_PZZ_1a_N8_U7k_Nj8w_1e5e370eff.png",
      },
      eatable: {
        url: "https://s3.venue.in.th/l_K_Ovo4pjjn_NBS_Yi_Hc5a_Ak_N_2n_Bl_Zd_T_To_J_Ea6_Gq_Xes_OF_g_Ae_P1_Rjrr_BFG_6mng_Iu_P_Akw_5fdd964546.png",
      },
      openrice: {
        url: "https://s3.venue.in.th/e_HPT_6_Rvg_P_Cvp_Tv3m_Iz_Ve_LSH_Nc_R2_Ld_L_Prisuc_W_Aw_HFQJ_Vi_Q_One5wy19b_NSL_2eqbpkjc_Y_81c808f384.png",
      },
      gowabi: {
        url: "https://s3.venue.in.th/images_63738e7e38.jpeg",
      },
      klook: {
        url: "https://s3.venue.in.th/oi_Wp_ZPNU_77_Yig_Mo_C1ia_Xds_X_Do_U34_PWP_63_M5c0e_ZCR_l6_O3_WT_Pn_D48_Cubgmto_Q_Eah_P_w_de9ea54f47.png",
      },
      eatigo: {
        url: "https://s3.venue.in.th/uz2_M4x_CF_Myr_Yk_Y_Elyw8_AVM_Rey_In_Q_Wxa0f_CMK_Adza_Ndm_ZB_9_IE_Es_K_Qzrj_HIA_93pg_SU_ee5069fa31.png",
      },
      booking: {
        url: "https://s3.venue.in.th/3_Kf2_Yyo_yg14_Js9_QSZNGT_Az_Vt_Zdl_Eaxce_PVCD_Hza_Ph_AH_6u_E_Vd_T7l_Ttz19_Yrx1po_Vbpal_s256_rw_ba5c09394c.webp",
      },
      agoda: {
        url: "https://s3.venue.in.th/Q_Fl5_Rn_Jn_Ca_Apuw_SY_5_Gky_Pk1_Yq_F_Rdeq_64_E_Hae_Ne_Y_Id3_Hw_Y9_Uqjf5_Jk_R_Ve_AT_Zxuu_Kez5o_08a5bc0a66.png",
      },
      tripadvisor: {
        url: "https://s3.venue.in.th/Eo_Rc_Rtru5_F_Lis_Rd0k_CJ_5_Ee_Tb_DQS_8o_Zt_LYI_Tsg_58_Gv52ryuj_Jtq_Yw_QU_Yf_D_Dw_Y3_Y9c2_U_a93799697d.png",
      },
      resy: {
        url: "https://s3.venue.in.th/Nli_O_Gci_JF_8_v8m_T_Pj_Dn_FI_4_L_qrtmqz_G0_C_Tx5u0_LH_Ug_FMNO_66_QB_1q_Hw_Kf_Wfip_DVHHY_048b1a4c6b.png",
      },
      opentable: {
        url: "https://s3.venue.in.th/6_EU_Alv_RT_1_Umzip_X_Vyvtlt_Q0n_Lh_OLB_wkghb_HEI_Bdsczl4_Ln_Eh_W6o7e_HS_Zhxa_Ay0_Wc_eade25cd18.png",
      },
      tablecheck: {
        url: "https://s3.venue.in.th/Table_Check_jpg_e4abf4794b.aspx",
      },
      facebook: {
        url: "https://s3.venue.in.th/KCMT_Yui_Tr_Kom4_Vyf0_G4foet_V_Owh_K_Wz_Nb_H_Wum_V73_I_Xex_A_Iy5_T_Tg_Zip_L52_W_Tt8_ICL_o_Io_01a299e85c.png",
      },
      instagram: {
        url: "https://s3.venue.in.th/VRM_Wk_E5p3_Ck_Wh_Js6nv_9_Zs_L_As1_Q_Og5ob1_3qg_rckw_YW_7yp1f_Mr_Y_Zqn_E_Fpk0_Io_VP_4_LM_12f0569ace.png",
      },
      line: {
        url: "https://s3.venue.in.th/74i_M_Ob_G1vs_R3_Kfm82_Rj_ER_Fhf99_QFMNIY_211o_Mv_N636_g_U_Lghb_RB_Mjp_VF_Tj_OK_36ox_Cbs_50869ab4b3.png",
      },
      "twitter-x": {
        url: "https://s3.venue.in.th/A_Rnrh0_J7i_Km_A_Bsk_Tonq_FAANRLGTG_Ug_nu_E4_PEM_Yw_Jav_L3n_Pt5u_Ws_U2_WO_D_Sg_V_m_OOM_4485813680.png",
      },
      tiktok: {
        url: "https://s3.venue.in.th/Bm_U_Vi_DVOKN_Je0_GY_Je22hsr7ju_Fnd_R_Vbvr1f_Gm_HG_Xq_Hf_Jj_NA_Xjd26bfu_GR_Qp_Vrp_J6_Yb_A_35a4e2b103.png",
      },
      youtube: {
        url: "https://s3.venue.in.th/6am0i3wal_Yw_N_Lc08_QO_Oh_R_Jtt_QENN_Gkhl_Kaj_XSE_Rf3_Jn_PVR_Qcz_Iyxw2w3_Dxe_MRTO_Sds_Y_f4eff792ef.png",
      },
      threads: {
        url: "https://s3.venue.in.th/G6j_K9_S77_RN_0laf9_6nh_Do3_A_Vxb_RP_9_Sg_Mmt8_Zm_Qj_KQ_2hibn9xh_OY_W5_Y_Fn_7st_JD_1_CA_ee64a782ec.png",
      },
      chope: {
        url: "https://s3.venue.in.th/chope_fc476e0327.png",
      },
      jpneasy: {
        url: "https://s3.venue.in.th/jpneasy_fd9e457b0f.png",
      },
    },
    storeDownload: {
      ios: {
        url: "https://s3.venue.in.th/ios_store_download_button_f012d18f26.png",
      },
      android: {
        url: "https://s3.venue.in.th/store_download_button_70d404d1a9.png",
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        /* Override style to apply solid color filter for CustomImageIcon component. */
        "#searchListItem_avatar_filter .solid-color-filter": {
          // display: "none" // Disable filter
          // floodColor: "currentColor" // Set solid color (default: currentColor).
        },
        "#diningCard_cover_filter .solid-color-filter": {},
        "#diningCard_avatar_filter .solid-color-filter": {},
        "#directoryCard_avatar_filter .solid-color-filter": {},
        "#placeDetail_avatar_filter .solid-color-filter": {},
        "#shopPromotion_avatar_filter .solid-color-filter": {},
        "#step_avatar_filter .solid-color-filter": {},
        "#directionOverview_avatar_filter .solid-color-filter": {},
        "#newShop_cover_filter .solid-color-filter": {},
        "#newShop_avatar_filter .solid-color-filter": {},
        "#stepOverview_avatar_filter .solid-color-filter": {},
        /* End Override style to apply solid color filter for CustomImageIcon component. */

        // Used with usePageSideBar layout to control content and sidebar structure within the app.
        "&.is-open-sidebar": {
          "& #map": {
            marginLeft: `${
              mixins.collapsedContent.width - mixins.content.width
            }px`,
          },
          "& .AppLayout-indoorMapWrapper": {
            width: mixins.collapsedContent.width,
          },
          "& .ContentWithAside-contentWrapper": {
            width: mixins.collapsedContent.width,
          },
          "& .ContentWithAside-asideWrapper": {
            width: mixins.expandedContent.width,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlinedSizeMedium: {
          fontSize: "1.25rem",
          fontWeight: 400,
        },
        startIcon: {
          marginRight: theme.spacing(0.75),
        },
        endIcon: {
          marginLeft: theme.spacing(0.75),
        },
        sizeMedium: {
          paddingTop: theme.spacing(2),
        },
      },
    },
    AutoplaySlider: {
      styleOverrides: {
        root: {
          position: "relative",
          overflow: "hidden",
        },
      },
    },
    SplitrPlayer: {
      defaultProps: {
        iframeOptions: {},
      },
      styleOverrides: {
        iframe: {
          top: theme.spacing(5),
          left: theme.spacing(5),
          bottom: theme.spacing(5),
          width: "1400px",
          height: "1000px",
          pointerEvents: "none",
          position: "absolute",
          zIndex: 1,
          borderRadius: "32px",
          "&.hidden": {
            display: "none",
          },
        },
      },
    },
    AppLayout: {
      styleOverrides: {
        headerWrapper: { display: "none" },
        indoorMapWrapper: {
          position: "absolute",
          margin: theme.spacing(5),
          top: 0,
          width: mixins.content.width,
          maxWidth: mixins.content.width,
          overflow: "hidden",
          borderRadius: "32px",
          transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
        contentWrapper: {
          position: "relative",
        },
      },
    },
    AppMapLayout: {
      styleOverrides: {},
    },
    AppPageLayout: {
      styleOverrides: {
        root: {
          height: "100%",
          overflow: "hidden",
        },
      },
    },
    AppContentWithAside: {
      styleOverrides: {
        root: {
          height: "100dvh",
          display: "flex",
          width: "100dvw",
          padding: theme.spacing(5),
          gap: theme.spacing(5),
        },
        contentWrapper: {
          width: mixins.content.width,
          position: "relative",
          flexShrink: 0,
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
        asideWrapper: {
          position: "relative",
          width: mixins.aside.width,
          flexShrink: 0,
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
      },
    },
    AppMapPageLayout: {
      styleOverrides: {
        root: {
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          pointerEvents: "none",

          "& .ContentWithAside-contentWrapper": {
            pointerEvents: "inherit",
            "& > *": {
              pointerEvents: "all",
            },
          },
          "& .ContentWithAside-asideWrapper": { pointerEvents: "all" },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 50,
          height: 30,
          padding: 0,
          margin: theme.spacing(1),
          display: "flex",
          alignItems: "center",
          "& .MuiSwitch-thumb": {
            color: "white",
            boxShadow: "none",
            width: 20,
            height: 20,
            borderRadius: 9999,
            transition: theme.transitions.create(["width"], {
              duration: 200,
            }),
          },
          "& .MuiSwitch-track": {
            borderRadius: 9999,
            opacity: 1,
            backgroundColor: theme.palette.grey[100],
            boxSizing: "border-box",
          },
          "&:active": {
            "& .MuiSwitch-thumb": {
              width: 20,
            },
            "& .MuiSwitch-switchBase.Mui-checked": {
              transform: "translateX(9px)",
            },
          },
          "& .MuiSwitch-switchBase": {
            padding: 5,
            "&.Mui-checked": {
              transform: "translateX(20px)",
              "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
              },
            },
            "&.Mui-disabled": {
              "& .MuiSwitch-thumb": {
                backgroundColor: theme.palette.grey[100],
              },
              "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.grey[50],
              },
              "&.Mui-checked": {
                "& .MuiSwitch-thumb": {
                  backgroundColor: theme.palette.grey[300],
                },
                "& + .MuiSwitch-track": {
                  backgroundColor: theme.palette.grey[100],
                },
              },
            },
          },
        },
        sizeSmall: {
          width: 30,
          height: 18,
          "&:active": {
            "& .MuiSwitch-thumb": {
              width: 16,
            },
            "& .MuiSwitch-switchBase.Mui-checked": {
              transform: "translateX(9px)",
            },
          },
          "& .MuiSwitch-switchBase": {
            padding: 2,
            "&.Mui-checked": {
              transform: "translateX(12px)",
            },
          },
          "& .MuiSwitch-thumb": {
            width: 14,
            height: 14,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.grey[500],
          "&.Mui-disabled": {
            backgroundColor: "#ECECEC",
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreIcon,
      },
      styleOverrides: {
        select: {
          padding: theme.spacing(1.5, 4, 1.5, 2),
          borderRadius: "8px",
          fontSize: 12,
        },
        icon: {
          color: theme.palette.primary.main,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          fontSize: "0.75rem",
        },
      },
    },
    AppSidebar: {
      styleOverrides: {
        wrapper: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        header: {},
        body: {
          flex: 1,
        },
        footer: { marginBottom: theme.spacing(4) },
        playerButton: {
          flex: 1,
          padding: theme.spacing(1.5, 3),
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
      },
    },
    AppDining: {
      styleOverrides: {
        filterContainer: {
          paddingLeft: 0,
          paddingBottom: 3,
        },
        filterButton: {
          whiteSpace: "nowrap",
          gap: theme.spacing(2),
          "& .MuiSvgIcon-root": {
            marginRight: theme.spacing(1),
          },
          ":first-of-type": {
            marginLeft: theme.spacing(3),
          },
        },
        diningImageCard: {},
        filterSection: {
          position: "absolute",
          left: "50%",
          zIndex: 2,
          transform: "translateX(-50%)",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          bottom: 0,
          width: "100%",
          maxWidth: "calc(100% - 196px)", // 196px = 98px (padding content side) * 2
          marginBottom: theme.spacing(3),
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 1,
            position: "absolute",
            right: "-4px",
            top: 0,
            bottom: 0,
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
            zIndex: 1,
            position: "absolute",
            left: "-4px",
            top: 0,
            bottom: 0,
          },
          "& .MuiToggleButton-root": {
            alignItems: "center",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(2),
            padding: 0,
            margin: "0 auto",
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: 0,
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
        },
        scrollPane: {
          padding: 0,
        },
        venueSelector: {
          display: "none",
          position: "fixed",
          bottom: "175px",
          right: "690px",
          zIndex: 2,
        },
        contentWrapper: {
          height: "100%",
        },
        emptyDataWrapper: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "370px",
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridAutoRows: "max-content",
          gridTemplateColumns: "repeat(5,1fr)",
          gap: theme.spacing(2.5),
          padding: theme.spacing(0, 8.35),
          overflowY: "auto",
          height: "calc(100% - 80px)",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "&.emptyList": {},
        },
        gridItem: {
          height: "226px",
          width: "226px",
        },
        pageCard: {
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: 80,
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 2.8%, rgba(255, 255, 255, 0.00) 50%)",
          },
        },
        pageCardContent: {},
        subCategoryFilterBar: {
          "& .MuiToggleButton-root": {
            height: "48px",
          },
        },
        levelHeader: {
          display: "flex",
          gap: theme.spacing(3),
          position: "sticky",
          top: 0,
          background: theme.palette.background.paper,
          zIndex: 10,
          padding: theme.spacing(2, 0),
          gridColumn: "1 / -1",
          "& .MuiTypography-root": {
            fontWeight: 700,
            fontSize: "2.5rem",
          },
        },
        divider: {
          flex: 1,
          alignSelf: "center",
          borderColor: theme.palette.divider,
          borderWidth: "1px",
        },
      },
    },
    BaseModal: {
      styleOverrides: {
        root: {},
        container: {
          maxHeight: "1080px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        closeIconButton: {
          marginTop: theme.spacing(2.5),
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          width: "82px",
          height: "82px",
          borderRadius: "50%",
          ":hover": {
            background: theme.palette.background.paper,
          },
        },
        closeIcon: {
          width: "20px",
          height: "20px",
        },
      },
    },
    PromotionsCarousel: {
      defaultProps: {
        promotionCarouselOption: {
          gap: theme.spacing(4),
          // replace `415` with eventCard width
          fixedWidth: 415,
        },
      },
      styleOverrides: {
        root: {
          width: "1330px",
          height: "1080px",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "24px",
          margin: theme.spacing(5),
        },
        header: {
          padding: theme.spacing(4, 3, 1.5, 3),
          "& .MuiCardHeader-title": {
            color: theme.palette.text.primary,
            fontSize: "2rem",
            fontWeight: 700,
            lineHeight: "112%",
          },
        },
        cardContent: {},
        // duplicate `carouselContainer` and `carousel` styles from `PromotionPage`
        carouselContainer: {
          position: "relative",
          top: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            left: 0,
            zIndex: 1,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            right: 0,
            zIndex: 1,
          },
        },
        carousel: {
          width: "100%",
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            width: "20px",
            height: "20px",
            backgroundColor: theme.palette.primary.main,
            borderRadius: 30,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
          },
          "& .splide__track": {
            margin: 0,
            padding: theme.spacing(0, 3.75, 1.5, 3.75),
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "scale(1)",
              opacity: 1,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
      },
    },
    PromotionDetailCard: {
      styleOverrides: {
        root: {
          width: "1330px",
          height: "1080px",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "24px",
          margin: theme.spacing(5),
        },
        detail: {
          "& .DetailPage-pageCardContent": {
            // replace `595px` with promotion gallery width
            gridTemplateColumns: "595px 1fr",
          },
        },
      },
    },
    OccupantPromotionModal: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        closeIconButton: {
          position: "absolute",
          top: 12,
          right: 12,
          borderRadius: "16px",
          boxShadow:
            "0 50px 14px 0 rgba(0, 0, 0, 0.00), 0 32px 13px 0 rgba(0, 0, 0, 0.01), 0 18px 11px 0 rgba(0, 0, 0, 0.05), 0 8px 8px 0 rgba(0, 0, 0, 0.09), 0 2px 4px 0 rgba(0, 0, 0, 0.10)",
          padding: theme.spacing(1.5, 3),
          marginTop: 0,
        },
        promotionsCarouselStyle: {},
        promotionDetailCardStyle: {},
      },
    },
    PlaceDetailPage: {
      styleOverrides: {
        pageCardSideBar: {},
        occupantPromotionModal: {},
        bottomSidebarAction: {
          display: "none",
        },
      },
    },
    DiningCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          width: "226px",
          height: "226px",
        },
        cardActionArea: {
          height: "100%",
          width: "100%",
          "&:after": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.84))",
          },
        },
        backgroundImage: {
          width: "100%",
          height: "100%",
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          padding: theme.spacing(1),
          zIndex: 1,
        },
        highlightIconChip: {
          display: "none",
          justifyContent: "center",
          alignItems: "center",
          height: "24px",
          width: "24px",
          padding: theme.spacing(0),
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.error.main,
          fontWeight: 700,
          marginRight: "auto",
          "& .MuiChip-label": {
            padding: 0,
            margin: "auto",
          },
        },
        highlightIcon: {
          width: "16px",
          height: "16px",
          display: "flex",
          alignItems: "center",
        },
        highlightTextChip: {
          display: "none",
          padding: 0,
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.error.main,
          fontWeight: 400,
          marginRight: "auto",
        },
        levelChip: {
          display: "flex",
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.primary.light,
          fontSize: "1rem",
          fontWeight: 700,
          marginLeft: "auto",
          "& .MuiChip-label": {
            padding: 0,
          },
        },
        newShopChip: {
          display: "none",
        },
        comingSoonChip: {
          display: "none",
        },
        adsChip: {
          padding: theme.spacing(1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: alpha(theme.palette.grey[800], 0.6),
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 700,
            color: theme.palette.grey[200],
          },
        },
        fallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.common.white,
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        fallbackImageIcon: {
          height: "64px",
          width: "64px",
          zIndex: 1,
        },
        avatar: {
          width: "68px",
          height: "68px",
          borderRadius: "12px",
          marginRight: theme.spacing(2),
          background: theme.palette.background.paper,
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
            color: theme.palette.text.primary,
          },
        },
        subHeader: {
          fontSize: "0.75rem",
          color: theme.palette.common.white,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "90%",
          "&.sub-category-text": {
            display: "none",
          },
          "&.booth-name-text": {
            display: "none",
          },
          "&.location-text": {
            display: "none",
          },
        },
        cardHeader: {
          padding: theme.spacing(1.5),
          paddingBottom: theme.spacing(1),
          position: "absolute",
          minHeight: "92px",
          width: "100%",
          bottom: 0,
          zIndex: 1,
          "& .MuiCardHeader-title": {
            lineHeight: 1.3,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            fontWeight: 700,
            fontSize: "1rem",
          },
          "& .MuiCardHeader-content": {
            color: theme.palette.common.white,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignSelf: "stretch",
          },
          "& .MuiCardHeader-avatar": {
            marginRight: 0,
          },
        },
      },
    },
    AppCategoryFilterButton: {
      styleOverrides: {
        root: {
          padding: 0,
          width: 85,
          flexDirection: "column",
          justifyContent: "start",
          gap: theme.spacing(1),
          border: "none",
          color: theme.palette.text.primary,
          "&.Mui-selected": {
            "& .MuiSvgIcon-root": {
              color: theme.palette.primary.contrastText,
            },
            "& .MuiTypography-root": {
              color: theme.palette.primary.main,
            },
            "& .MuiBox-root": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          "&.Mui-selected, &.Mui-selected:hover, &.MuiToggleButton-root:hover":
            {
              backgroundColor: "unset",
            },
        },
        label: {
          fontSize: "0.75rem",
          textAlign: "center",
          lineHeight: 1.1,
          color: theme.palette.text.primary,
          fontWeight: 600,
          letterSpacing: "0.24px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          whiteSpace: "normal",
          wordBreak: "break-word",
          width: 100,
        },
        icon: {
          width: 80,
          height: 80,
          padding: theme.spacing(1.25),
          borderRadius: "8px",
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.10)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderColor: "none",
          "& .MuiSvgIcon-root": {
            width: 48,
            height: 48,
          },
        },
      },
    },
    AppCategoryFilterChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1, 2),
          borderRadius: "8px",
          boxShadow: "none",
          background: theme.palette.common.white,
          border: `1px solid ${theme.palette.grey[200]} `,
          whiteSpace: "nowrap",
          height: "40px",
          color: theme.palette.grey[600],
          fontWeight: 400,
          "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            margin: 0,
          },
          "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            border: `1px solid ${theme.palette.grey[200]} `,
            margin: 0,
          },
          "&.Mui-selected": {
            background: theme.palette.primary.main,
            "& svg": {
              fill: theme.palette.primary.contrastText,
            },
          },
          ":hover": {
            background: theme.palette.common.white,
          },
        },
        label: {
          fontSize: "0.875rem",
          padding: theme.spacing(0, 1.5),
          letterSpacing: "0.00938em",
        },
        icon: {
          display: "flex",
          alignItems: "center",
          fill: theme.palette.text.primary,
          "& svg": {
            width: 16,
            height: 16,
            fill: theme.palette.grey[600],
            marginLeft: theme.spacing(0.5),
            marginRight: theme.spacing(-0.75),
          },
        },
      },
    },
    AppCategoryFilterBar: {
      styleOverrides: {
        root: {},
        filterButton: {},
      },
    },
    WelcomePanel: {
      defaultProps: {
        showNavigation: false,
        showQuickSearch: true,
      },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[50],
        },
        panelContainer: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-end",
        },
        line: {
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "3px",
          border: "none",
          background: `linear - gradient(90deg, ${theme.palette.primary.main} 0 %, ${theme.palette.common.white} 100 %)`,
        },
        content: {
          position: "relative",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(6.75, 3, 2),
          [theme.breakpoints.up("sm")]: {
            width: 460,
          },
        },
        logoContainer: {
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          marginBottom: theme.spacing(3),
          "& img": {
            maxWidth: 130,
          },
        },
        searchBarContainer: {
          marginBottom: theme.spacing(2),
          width: "100%",
        },
        navItem: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          color: "white",
          flexBasis: 0,
          fontSize: theme.typography.subTitle.fontSize,
          fontWeight: theme.typography.fontWeightRegular,
          lineHeight: "19px",
          flexGrow: "1",
          textAlign: "center",
          "& .MuiButton-startIcon": {
            margin: theme.spacing(0, 0, 1.5),
            width: 20,
            height: 20,
          },
        },
        horizontalMenuContainer: {
          padding: 0,
        },
      },
    },
    AppHeader: {
      styleOverrides: {
        root: {
          position: "sticky",
          left: 0,
          top: 0,
          right: 0,
          justifyContent: "center",
          minHeight: mixins.hKioskHeader.height,
          backgroundColor: theme.palette.grey[50],
          boxShadow: "none",
          width: "100%",
          color: theme.palette.text.primary,
          fontWeight: 600,
        },
        toolbar: {
          padding: theme.spacing(0, 9),
          maxWidth: "none",
          minHeight: mixins.mobileHeader.height,
          justifyContent: "space-between",
          width: "100%",
          [theme.breakpoints.up("md")]: {
            padding: theme.spacing(0, 8),
            margin: `0 auto`,
            maxWidth: "none",
          },
        },
        logoContainer: {
          display: "inline-block",
        },
        titleContainer: {
          display: "none",
        },
        clockContainer: {
          display: "inline-block",
        },
        backButtonContainer: {
          display: "none",
        },
        line: {
          display: "none",
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "3px",
          border: "none",
          background: `linear - gradient(90deg, ${theme.palette.primary.main} 0 %, ${theme.palette.common.white} 100 %)`,
        },
      },
    },
    AppClock: {
      defaultProps: {
        dateFormat: "LLL",
        timeFormat: "hh:mm",
        timeUnitFormat: "A",
      },
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          textTransform: "uppercase",
          gap: theme.spacing(8),
          lineHeight: 1.2,
          "& .MuiDivider-root": {
            display: "none",
          },
        },
        timeWrapper: {
          fontWeight: 400,
          textAlign: "left",
          fontSize: "24px",
        },
        dateContainer: {
          gap: theme.spacing(1.5),
        },
        divider: {},
        timeContainer: {
          gap: theme.spacing(1.5),
        },
        dateText: {
          fontWeight: 400,
          fontSize: "24px",
        },
        timeLabel: {
          display: "none",
        },
        timeText: {},
        timeUnitText: {
          fontWeight: 400,
          fontSize: "24px",
          marginBottom: theme.spacing(2),
        },
        icon: {
          "& .MuiSvgIcon-root": {
            width: 45,
            height: 45,
          },
        },
      },
    },
    // Navigation
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          width: "100%",
          overflow: "hidden",
        },
      },
    },

    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          maxWidth: "unset",
          padding: theme.spacing(1, 5),
          "& .MuiSvgIcon-root": {
            marginBottom: 8,
            width: 20,
            height: 20,
          },
          "&.Mui-selected": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:after": {
              display: "none",
            },
          },
          "&.Mui-disabled": {
            color: theme.palette.action.disabled,
            "& .MuiSvgIcon-root": {
              color: theme.palette.action.disabled,
            },
          },
        },
        label: {
          textAlign: "left",
          fontSize: "1rem",
          textTransform: "uppercase",
        },
      },
    },
    VuiNavigationControl: {
      styleOverrides: {
        wrapper: {
          "> *": {
            flex: 1,
          },
        },
        navigationAction: {},
        languageButton: {
          flexDirection: "column",
          color: "text.secondary",
          background: "none",
          "&:hover": { background: "none" },
        },
      },
    },
    AppKioskNavigation: {
      styleOverrides: {
        root: {
          height: "100%",
          maxWidth: "100%",
        },
        menuButton: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          gap: theme.spacing(2),
          alignItems: "center",
          color: theme.palette.text.secondary,
          fontWeight: 400,
          "& .MuiSvgIcon-root": {
            width: 48,
            height: 48,
            margin: 0,
          },
          "& .MuiBottomNavigationAction-label": {
            fontSize: "1.5rem",
          },
          padding: theme.spacing(0, 5),
          "&.Mui-selected": {
            color: theme.palette.primary.contrastText,
            "& .MuiBottomNavigationAction-label": {
              fontSize: "1.5rem",
            },
          },
        },
        navigationWrapper: {
          height: "100%",
        },
        navigationContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
          gap: 0,
          height: "100%",
          alignItems: "stretch",
        },
        toolbarContainer: {
          display: "none",
        },
        searchBarContainer: {
          display: "none",
        },
        actionContainer: {
          display: "none",
        },
        actionButton: {
          minWidth: 128,
          backgroundColor: theme.palette.common.white,
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
          "& .MuiSvgIcon-root": {
            marginRight: 0,
            width: 32,
            height: 32,
          },
        },
      },
    },
    AppBanner: {
      styleOverrides: {
        root: {
          height: "62px",
          margin: theme.spacing(5, 5, 3),
          backgroundSize: "172px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },
      },
    },
    AppFooter: {
      styleOverrides: {
        root: {
          height: mixins.hKioskFooter.height,
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
        },
      },
    },
    AppTopBar: {
      styleOverrides: {
        root: {
          display: "none",
        },
        ordinalSelector: {
          position: "static",
          "& .OrdinalSelector-root": {},
          "& .OrdinalSelector-list": {
            borderRadius: 9999,
            width: "48px",
            height: "48px",
            padding: theme.spacing(0.4),
          },
          "& .OrdinalSelector-label": {},
          "& .OrdinalSelector-button": {
            height: "100%",
          },
        },
        backButton: {
          color: theme.palette.primary.main,
        },
      },
    },
    DirectionSearchInput: {
      styleOverrides: {
        directionSearchWrapper: {
          boxShadow: theme.shadows[1],
          background: theme.palette.common.white,
          padding: theme.spacing(3, 2),
          borderRadius: "10px",
          display: "flex",
        },
        backIconWrapper: {
          display: "flex",
          alignItems: "start",
          justifyContent: "center",
          marginRight: theme.spacing(1),
        },
        directionWrapper: {
          flexGrow: 1,
          display: "flex",
        },
        switchIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: theme.spacing(1),
        },
        directionInputWrapper: {
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        },
        directionIconWrapper: {
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          marginRight: theme.spacing(1.5),
        },
        directionInput: {
          fontSize: "0.875rem",
          fontWeight: 500,
          flexGrow: 1,
          padding: theme.spacing(0, 0.5),
          "& .MuiInputBase-input": {
            padding: 0,
          },
        },
        iconButton: {
          color: theme.palette.text.primary,
          fontSize: "24px",
          margin: "-5px",
        },
        divider: {
          margin: theme.spacing(1, 0),
          borderBottomWidth: "1px",
        },
        clearIconButton: {
          color: theme.palette.text.primary,
          fontSize: "24px",
          margin: "-5px",
          "& .MuiSvgIcon-root": {
            height: "8px",
            width: "8px",
          },
        },
      },
    },
    AppDirectionSearch: {
      styleOverrides: {
        headerWrapper: {
          display: "none",
        },
        paper: {
          borderRadius: "10px",
          padding: theme.spacing(0.75, 1.25),
          display: "flex",
          alignItems: "center",
        },
        formControlLabel: {
          margin: 0,
          "& .MuiFormControlLabel-label": {
            fontWeight: 500,
            marginLeft: theme.spacing(2),
          },
        },
      },
    },
    AppMap: {
      styleOverrides: {
        toolbarContainer: {
          position: "fixed",
          bottom: 64,
          display: "flex",
          flexDirection: "column",
        },
        quickLinkContainer: {
          overflow: "hidden",
          padding: theme.spacing(0, 4),
          display: "flex",
          order: 0,
          maxWidth: "1410px",
        },
        ordinalSelectMenu: {
          position: "absolute",
          bottom: 200,
          right: 40,
        },
        ordinalSelectSplide: {
          display: "none",
        },
        indoorMapContainer: {
          height: "100%",
          borderRadius: `16px`,
          overflow: "hidden",
          "& #map": {
            marginLeft: 0,
            width: mixins.content.width,
            height: mixins.content.height,
          },
        },
        venueSelector: {
          display: "none",
        },
        locationButtonContainer: {
          display: "flex",
          position: "absolute",
          right: 40,
          bottom: 96,
        },
      },
    },
    AppNavigationStep: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
        },
        closeButton: {
          position: "absolute",
          top: "12px",
          right: "12px",
          width: "82px",
          height: "82px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "24px",
          background: theme.palette.background.default,
          color: theme.palette.text.primary,
          "& svg": {
            width: "20px",
            height: "20px",
          },
        },
        headerContainer: {
          width: "100%",
          display: "flex",
          gap: theme.spacing(2),
          marginBottom: theme.spacing(4),
        },
        logoContainer: {},
        occupantLogo: {
          width: "108px",
          height: "108px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "12px",
          margin: 0,
        },
        venueLogo: {
          display: "none",
        },
        titleText: {
          paddingRight: theme.spacing(10),
          fontSize: "2rem",
          fontWeight: 700,
          color: theme.palette.text.primary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 3,
          overflow: "hidden",
          wordBreak: "break-word",
          lineHeight: "1.2",
        },
        routeDescription: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.75),
          alignItems: "center",
          color: theme.palette.text.secondary,
          paddingBottom: theme.spacing(3),
          width: "100%",
        },
        highlightText: {
          fontWeight: 700,
          color: theme.palette.text.primary,
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          maxWidth: 192,
          fontSize: "1.25rem",
        },
        divider: {
          width: "100%",
          marginBottom: theme.spacing(4),
        },
        listItemIcon: {
          display: "none",
        },
        originText: {
          display: "none",
        },
        originIcon: {
          width: "40px",
          height: "40px",
        },
        destinationIcon: {
          width: "40px",
          height: "40px",
        },
        actionContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "auto",
          gap: theme.spacing(3),
          width: "100%",
        },
        stepContainer: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: theme.spacing(1),
          marginRight: "auto",
          marginBottom: theme.spacing(2),
        },
        stepItem: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(1.25),
        },
        ordinalSelector: {
          position: "absolute",
          bottom: "24px",
          right: "24px",
        },
        playerActionContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: theme.spacing(2),
          width: "100%",
          "& .prevButton": {},
          "& .playButton": {
            display: "none",
          },
          "& .nextButton": {},
        },
        primaryButton: {
          flex: 1,
          height: "80px",
          borderRadius: "24px",
          "& .MuiTypography-root": {
            fontSize: "1rem",
            fontWeight: 700,
          },
        },
        secondaryButton: {
          flex: 1,
          height: "80px",
          borderRadius: "24px",
          "& .MuiTypography-root": {
            fontSize: "1rem",
            fontWeight: 700,
          },
        },
        stepProgressBar: {
          height: 524,
          padding: 0,
          "& > .MuiStepper-root": {
            padding: theme.spacing(0, 0, 0, 2.875),
          },
        },
        sidebarContent: {},
        routeDescriptionStack: {
          flexDirection: "column",
        },
        cooldownProgress: {
          display: "none",
          marginTop: theme.spacing(1.5),
          width: "100%",
        },
        bottomSidebarAction: {
          display: "none",
        },
      },
    },
    AppFeatureDetail: {
      styleOverrides: {
        root: {
          position: "relative",
          overflow: "initial",
          boxShadow: "none",
        },
        section: {
          margin: theme.spacing(3, 0),
          "&:first-of-type": {
            marginTop: 0,
          },
          color: theme.palette.text.secondary,
        },
        galleryImage: {
          objectFit: "cover",
          height: 130,
          width: 182,
          display: "block",
          boxShadow: theme.shadows[2],
          borderRadius: "6px",
          cursor: "pointer",
        },
        divider: {
          borderBottom: `1px solid #ECECEC`,
        },
        contactButton: {
          textTransform: "lowercase",
          display: "flex",
          marginBottom: theme.spacing(2.5),
          color: theme.palette.text.primary,
          "& .MuiSvgIcon-root": {
            color: theme.palette.primary.main,
          },
        },
        contactWrapper: {
          marginBottom: theme.spacing(1.25),
        },
        sectionTitle: {
          fontSize: theme.typography.subtitle1.fontSize,
          fontWeight: theme.typography.fontWeightBold,
          marginBottom: theme.spacing(2),
          color: theme.palette.text.primary,
        },
      },
    },
    AppImageModal: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(2),
        },
        imageWrapper: {
          position: "relative",
          outline: "none",
          maxWidth: "80vw",
          height: "60vh",
          "& img": {
            borderRadius: "8px",
            height: "100%",
          },
        },
        closeButton: {
          color: theme.palette.common.white,
          position: "absolute",
          top: theme.spacing(-4.5),
          right: theme.spacing(-1),
          [theme.breakpoints.up("sm")]: {
            right: theme.spacing(-2),
          },
        },
      },
    },
    AppYouAreHereMarker: {
      styleOverrides: {
        root: {
          "& .primary": {
            fill: theme.palette.primary.main,
          },
          "& .primary-light": {
            fill: theme.palette.secondary.main,
          },
          "& .primary-border": {
            stroke: theme.palette.primary.main,
          },
          "& .text-primary": {
            fill: theme.palette.text.primary,
          },
          "& .secondary": {
            fill: theme.palette.secondary.main,
          },
        },
      },
    },
    DirectionStep: {
      styleOverrides: {
        originIcon: {
          fill: theme.palette.primary.main,
          width: 37,
          height: 37,
        },
        destinationIcon: {
          fill: theme.palette.error.main,
          width: 28,
          height: 47,
        },
        highlightedText: {
          color: theme.palette.text.primary,
          textAlign: "inherit",
          fontWeight: 700,
          lineHeight: "inherit",
          fontSize: "inherit",
        },
      },
    },
    SkeletonDirectionOverviewSidebar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(2),
          "&>*": {
            width: "100%",
          },
        },
        divider: {
          borderColor: "#E4E2E3",
          marginTop: theme.spacing(5),
          marginBottom: theme.spacing(2),
          width: "100%",
        },
        headerWrapper: {
          display: "flex",
          padding: 0,
          flexDirection: "row",
          gap: theme.spacing(3),
          alignItems: "start",
        },
        locationText: {
          height: "40px",
          width: "250px",
        },
        durationText: {
          width: "165px",
          height: "50px",
        },
        distanceText: {
          width: "94px",
          height: "38px",
        },
        travelInfoText: {
          width: "320px",
          height: "38px",
        },
        contentWrapper: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: 0,
        },
        durationWrapper: {
          height: "100%",
        },
        qrCodeContainer: {
          gridArea: "qr",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(3),
        },
        qrCode: {
          width: "118px",
          height: "118px",
        },
        qrcodeText: {
          width: "108px",
          height: "80px",
        },
        stepContainer: {
          marginTop: theme.spacing(5, 0),
        },
        stepListContainer: {
          width: "100%",
          height: "500px",
        },
        actionContainer: {
          marginTop: "auto",
        },
        startButton: {
          width: "100%",
          height: "80px",
        },
      },
    },
    SkeletonStepByStepSidebar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4, 4, 0),
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        stepContainer: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: theme.spacing(1),
          marginTop: theme.spacing(0.5),
          marginRight: "auto",
        },
        stepItem: {
          height: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(1.25),
        },
        locationAvatar: {
          width: "80px",
          height: "80px",
        },
        locationText: {
          width: "60px",
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: theme.spacing(2),
          width: "100%",
          marginTop: theme.spacing(4),
        },
        button: {
          width: "174px",
          height: "48px",
        },
        stepProgressBarContainer: {},
        stepProgressBar: {
          height: "400px",
          width: "300px",
        },
      },
    },
    AppDirectionOverview: {
      styleOverrides: {
        root: {
          height: "100%",
        },
        contentContainer: {
          height: "100%",
          position: "relative",
          padding: theme.spacing(4),
        },
        closeButton: {
          position: "absolute",
          top: "12px",
          right: "12px",
          width: "82px",
          height: "82px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "16px",
          background: theme.palette.background.default,
          color: theme.palette.text.primary,
          boxShadow:
            "0 50px 14px 0 rgba(0, 0, 0, 0.00),0 32px 13px 0 rgba(0, 0, 0, 0.01),0 18px 11px 0 rgba(0, 0, 0, 0.05),0 8px 8px 0 rgba(0, 0, 0, 0.09),0 2px 4px 0 rgba(0, 0, 0, 0.10)",
          "& svg": {
            width: "20px",
            height: "20px",
          },
        },
        titleText: {
          color: theme.palette.primary.main,
          marginBottom: theme.spacing(3),
          fontWeight: 700,
          fontSize: "2rem",
        },
        travelInfoContainer: {},
        routeDetailContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          paddingLeft: theme.spacing(3),
          marginTop: theme.spacing(1.5),
        },
        durationContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          alignItems: "center",
        },
        primaryText: {
          color: theme.palette.text.primary,
          fontWeight: 700,
          lineHeight: 1,
          fontSize: "2.5rem",
        },
        secondaryText: {
          color: theme.palette.text.secondary,
          lineHeight: 1,
          paddingTop: 0,
          fontSize: "2.125rem",
        },
        avoidStepButton: {
          display: "flex",
          flexDirection: "row-reverse",
          height: "52px",
          width: 242,
          borderRadius: "9999px",
          border: `1px solid ${theme.palette.divider}`,
          margin: theme.spacing(2.5, 0, 0, 3),
          "& .MuiTypography-root": {
            fontSize: "1.25rem",
            fontWeight: 400,
            textTransform: "capitalize",
            color: theme.palette.text.secondary,
          },
          "& .MuiFormControlLabel-label": {
            marginLeft: 0,
            fontSize: "1rem",
            fontWeight: 400,
            display: "flex",
          },
          "& svg": {
            color: theme.palette.text.secondary,
            height: 20,
            width: 20,
            marginRight: theme.spacing(1),
            display: "none",
          },
        },
        qrCodeContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          padding: theme.spacing(1.5),
          marginTop: theme.spacing(4),
        },
        qrCode: {
          width: "102px",
          height: "102px",
          padding: theme.spacing(0.25),
          border: `1px solid ${theme.palette.divider}`,
          "&:before": {
            display: "none",
          },
          "&:after": {
            display: "none",
          },
          "& .AppQRCode-content": {
            height: "100%",
            width: "100%",
            ":before": {
              display: "none",
            },
            ":after": {
              display: "none",
            },
          },
        },
        qrCodeCaptionContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        },
        qrcodePrimaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: theme.palette.text.primary,
          textAlign: "center",
        },
        qrcodeSecondaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          color: theme.palette.text.primary,
          textAlign: "center",
        },
        routeDescription: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.75),
          alignItems: "center",
          color: theme.palette.text.secondary,
          paddingBottom: theme.spacing(3),
        },
        highlightText: {
          fontWeight: 700,
          color: theme.palette.text.primary,
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          maxWidth: 192,
          fontSize: "1.25rem",
        },
        divider: {},
        stepContainer: {
          position: "relative",
          marginTop: theme.spacing(1.5),
          gap: theme.spacing(1),
        },
        stepListAvatarContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minWidth: "40px",
          height: "40px",
          marginRight: theme.spacing(1.25),
        },
        stepListContainer: {
          display: "flex",
          flexDirection: "column",
          overflow: "hidden auto",
          height: 300,
          maxWidth: "auto",
          gap: theme.spacing(1),
          padding: theme.spacing(3),
          maxHeight: 300,
          borderRadius: "12px",
          background: theme.palette.grey[50],
          marginTop: theme.spacing(1.25),
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.text.secondary,
          },
        },
        stepListItem: {
          padding: 0,
          "& .step": {
            backgroundColor: theme.palette.grey[500],
            color: theme.palette.primary.contrastText,
            width: "40px",
            height: "40px",
            fontSize: "1.25rem",
            "& svg": {
              height: "24px",
              width: "24px",
            },
          },
        },
        stepListItemText: {
          "& .MuiListItemText-primary": {
            color: theme.palette.text.primary,
            fontSize: "1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            lineHeight: 1.4,
            fontWeight: 400,
          },
          "& .MuiListItemText-secondary": {
            color: theme.palette.text.primary,
            fontSize: "1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: 400,
          },
        },
        connector: {
          display: "flex",
          marginLeft: theme.spacing(2.25),
          "& .MuiStepConnector-line": {
            background: "transparent",
            borderLeft: `4px dotted ${theme.palette.grey[300]}`,
            width: "4px",
            minHeight: "86px",
            height: "calc(100% + 40px)",
            margin: theme.spacing(-3.75, 0),
          },
          "&:last-of-type": {
            marginBottom: theme.spacing(1.75),
          },
        },
        logoImage: {
          width: "60%",
          objectFit: "contain",
          maxHeight: 34,
        },
        listItemIcon: {
          display: "none",
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.default,
          width: "80px",
          height: "40px",
          borderRadius: "16px",
          marginRight: theme.spacing(1),
        },
        actionContainer: {
          marginTop: theme.spacing(1.5),
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1),
          width: "100%",
        },
        startButton: {
          marginTop: "auto",
          height: "80px",
          flex: "1 1 100%",
          fontSize: "1.25rem",
          borderRadius: "24px",
        },
        ordinalSelectMenu: {
          position: "absolute",
          bottom: "24px",
          right: "24px",
        },
        locationButtonContainer: {
          display: "none",
        },
        routeDescriptionStack: {
          flexDirection: "column",
        },
        estimateTimeText: {
          fontSize: "1.75rem",
          fontWeight: 400,
          color: theme.palette.text.secondary,
        },
        stepsTitleText: {
          fontSize: "1.75rem",
        },
        bottomSidebarAction: {
          display: "none",
        },
      },
    },
    DirectionCardActions: {
      styleOverrides: {
        root: {
          gap: theme.spacing(2),
          height: "auto",
          padding: 0,
          display: "flex",
          flexDirection: "row",
        },
        actionButton: {
          [theme.breakpoints.down("sm")]: {
            fontWeight: 700,
            "&.MuiButton-outlined": {
              border: `1px solid ${theme.palette.grey[400]} `,
            },
            "& .MuiButton-startIcon": {
              marginRight: theme.spacing(1.25),
            },
          },
        },
      },
    },
    HomePage: {
      styleOverrides: {
        root: {
          top: 0,
          padding: theme.spacing(5),
          backgroundColor: theme.palette.background.default,
        },
        contentContainer: {
          height: "100%",
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
        },
        welcomePanelWrapper: {
          width: "400px",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.paper,
          borderRadius: "32px",
        },
        welcomeContainer: {
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          padding: theme.spacing(10, 0),
          gap: theme.spacing(30),
        },
        logoContainer: {},
        logoImage: {
          height: 80,
        },
        qrContainer: {
          display: "none",
        },
        qrCode: {
          paddingTop: theme.spacing(4),
          backgroundColor: "transparent",
          "& .AppQRCode-content": {
            width: 80,
            height: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            border: "none",
            //create corner border
            //https://stackoverflow.com/questions/38850419/how-to-create-multi-color-border-with-css
            //http://www.java2s.com/example/html-css/css-widget/add-border-only-to-corner.html
            ":before": {
              content: "''",
              display: "block",
              position: "absolute",
              borderTop: "3px solid",
              borderBottom: "3px solid",
              borderImage:
                "linear-gradient(to right, black 25%, transparent 25%, transparent 50%,transparent 50%, transparent 75%, black 75%) 3",
              height: 80,
              width: 80,
            },
            ":after": {
              display: "block",
              position: "absolute",
              content: "''",
              borderRight: "3px solid",
              borderLeft: "3px solid",
              borderImage:
                "linear-gradient(to bottom, black 25%, transparent 25%, transparent 50%,transparent 50%, transparent 75%, black 75%) 3",
              height: 80,
              width: 80,
            },
          },
          "& .AppQRCode-qrcode": {
            height: 65,
            width: 65,
            border: "none",
          },
          "& .AppQRCode-caption": {
            paddingTop: theme.spacing(2),
            fontWeight: 500,
            fontSize: "0.875rem",
            color: theme.palette.text.secondary,
          },
        },
        localeListContainer: {
          display: "none",
        },
        localeButton: {
          borderRadius: "50%",
          height: "40px",
          width: "40px",
          padding: 0,
          minWidth: 40,
          boxShadow: theme.shadows[3],
          "& .MuiAvatar-circular": {
            height: "35px",
            width: "35px",
          },
        },
        actionContainer: {
          position: "relative",
          display: "inline-block",
          "&:after, :before": {
            opacity: 0,
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            height: "100%",
            width: "100%",
            border: `2px solid ${alpha(theme.palette.primary.light, 0.7)}`,
            borderRadius: 9999,
            zIndex: -1,
          },
          "&:after": {
            animation: `ripple 2s infinite ${theme.transitions.easing.easeInOut}`,
          },
          "&:before": {
            animation: `ripple 2s infinite ${theme.transitions.easing.easeInOut} 0.3s`,
          },
        },
        actionButton: {
          display: "none",
        },
        homeActionButton: {},
        videoContainer: {
          display: "none",
        },
        screensaverContainer: {
          position: "relative",
          width: `${mixins.hKioskScreenSaver.width}px`,
          height: "100%",
          "& .AdMediaCarousel-root": {
            position: "absolute",
            zIndex: 1,
            top: 40,
            left: 40,
            bottom: 40,
            pointerEvents: "none",
            width: `${mixins.hKioskScreenSaver.width}px`,
            height: `${mixins.hKioskScreenSaver.height}px`,
            overflow: "hidden",
            borderRadius: "32px",
            background: theme.palette.common.black,
            "& .splide__slide": {
              width: `${mixins.hKioskScreenSaver.width}px`,
              height: `${mixins.hKioskScreenSaver.height}px`,
            },
            "& .splide__slide video,img": {
              width: `${mixins.hKioskScreenSaver.width}px`,
              height: `${mixins.hKioskScreenSaver.height}px`,
              objectFit: "cover",
            },
          },
        },
        carouselWrapper: {
          display: "none",
        },
        carouselScreenSaver: {},
        carouselMediaItem: {},
      },
    },
    FullScreenStart: {
      styleOverrides: {
        root: {
          display: "none",
        },
        actionButtonWrapper: {
          position: "relative",
          display: "inline-block",
          "&:after, :before": {
            opacity: 0,
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            height: "100%",
            width: "100%",
            border: `5px solid ${alpha(theme.palette.common.white, 0.4)} `,
            borderRadius: 9999,
            zIndex: -1,
          },
          "&:after": {
            animation: `ripple 3s infinite ${theme.transitions.easing.easeInOut} `,
          },
          "&:before": {
            animation: `ripple 3s infinite ${theme.transitions.easing.easeInOut} 0.5s`,
          },
        },
        actionButton: {
          position: "relative",
          fontSize: "1rem",
          textTransform: "uppercase",
          color: theme.palette.text.secondary,
          fontWeight: 700,
          borderRadius: 999,
          backgroundColor: theme.palette.common.white,
          transition: theme.transitions.create("all"),
          boxShadow: theme.shadows[10],
          padding: theme.spacing(1.25, 3),
          "&:hover": {
            boxShadow: theme.shadows[20],
            backgroundColor: theme.palette.common.white,
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
          },
          "& .MuiButton-startIcon>svg": {
            fontSize: "1.5rem",
            color: theme.palette.primary.main,
          },
          [theme.breakpoints.up("md")]: {
            transform: "scale(1.2)",
          },
        },
      },
    },
    DirectoryPage: {
      styleOverrides: {
        root: {
          "& .MuiList-root": {
            display: "none",
          },
          display: "flex",
          flexDirection: "column-reverse",
          gap: theme.spacing(1),
          margin: theme.spacing(0, -3),
        },
        filterSection: {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(3),
          top: 0,
          zIndex: 1,
          paddingTop: theme.spacing(3.75),
          "& .category-filterbar,& .subCategory-filterbar": {
            padding: theme.spacing(0, 1.5),
            position: "relative",
            maxWidth: "95%",
            margin: "0 auto",
            "&:after": {
              content: "''",
              display: "inline-block",
              width: "20px",
              background:
                "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
              zIndex: 1,
              position: "absolute",
              right: "2px",
              top: 0,
              bottom: 0,
            },
            "&:before": {
              content: "''",
              display: "inline-block",
              width: "20px",
              background:
                "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
              zIndex: 1,
              position: "absolute",
              left: "2px",
              top: 0,
              bottom: 0,
            },
          },
          "& .category-filterbar": {
            order: 0,
          },
          "& .subCategory-filterbar": {
            order: 1,
          },
          "&:before": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            top: -170,
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 2.8%, rgba(255, 255, 255, 0.00) 50%)",
          },
        },
        categoryFilterBar: {
          gap: theme.spacing(3),
          maxWidth: "100%",
          "& .MuiToggleButton-root": {
            width: "104px",
            height: "104px",
            gap: theme.spacing(2),
            padding: 0,
            borderRadius: "12px",
            border: "none",
            justifyContent: "center",
            ":not(:last-of-type)": {
              borderRadius: "12px",
            },
            ":not(:first-of-type)": {
              borderRadius: "12px",
            },
            "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
              border: "none",
              marginLeft: 0,
            },
            "& .MuiTypography-root": {
              color: theme.palette.text.secondary,
              fontWeight: 400,
              fontSize: "1rem",
              width: "98px",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            },
            "& .MuiBox-root": {
              borderRadius: "9999px",
              border: "none",
              width: "32px",
              height: "32px",
            },
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.main,
              ":hover": {
                backgroundColor: theme.palette.primary.main,
              },
              "& .MuiTypography-root": {
                color: theme.palette.primary.contrastText,
              },
            },
          },
        },
        subCategoryFilterBar: {
          gap: theme.spacing(2),
          margin: 0,
          "& .MuiToggleButton-root": {
            height: "48px",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButton-root.MuiToggleButtonGroup-grouped:first-of-type":
            {
              marginLeft: 0,
            },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
        },
        scrollPane: {
          padding: 0,
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridAutoRows: "max-content",
          gridTemplateColumns: "repeat(6,1fr)",
          gap: theme.spacing(2.5),
          overflowY: "auto",
          height: "800px",
          padding: theme.spacing(0, 9, 5),
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "&.emptyList": {
            height: "100%",
          },
          "&.with-sub-category": {
            height: "740px",
            minHeight: "740px",
          },
        },
        gridItem: {},
        emptyDataWrapper: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "370px",
        },
        pageCard: {},
        levelHeader: {
          display: "flex",
          gap: theme.spacing(3),
          position: "sticky",
          top: 0,
          background: theme.palette.background.paper,
          zIndex: 10,
          padding: theme.spacing(2, 0),
          gridColumn: "1 / -1",
          "& .MuiTypography-root": {
            fontWeight: 700,
            fontSize: "2.5rem",
          },
        },
        divider: {
          flex: 1,
          alignSelf: "center",
          borderColor: theme.palette.divider,
          borderWidth: "1px",
        },
      },
    },
    LevelFilterBar: {
      styleOverrides: {
        root: {
          padding: 0,
          "& .MuiToggleButton-root": {
            padding: theme.spacing(1, 3),
            flexShrink: 0,
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(3),
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: theme.spacing(3),
          },
        },
      },
    },
    DirectoryOccupantCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          display: "flex",
          height: "128px",
          borderRadius: "8px",
          border: `1px solid ${theme.palette.divider}`,
        },
        occupantLogo: {
          boxShadow: "none",
          width: "100%",
          minWidth: "128px",
          maxWidth: "128px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "100%",
          },
          "& .MuiSvgIcon-root": {
            width: "48px",
            height: "48px",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.25,
          },
        },
        levelContainer: {
          background: alpha(theme.palette.primary.main, 0.2),
          width: "28px",
          height: "28px",
          color: theme.palette.primary.main,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "4px",
          "& .MuiTypography-root": {
            fontSize: "0.75rem",
          },
        },
        divider: {
          margin: theme.spacing(0, 1.625),
        },
        venueLogo: {
          display: "none",
        },
        titleText: {
          fontSize: "1rem",
          fontWeight: 700,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          color: theme.palette.text.primary,
        },
        groupText: {
          fontSize: "0.75rem",
          fontWeight: 300,
          display: "none",
        },
        categoryText: {
          fontSize: "0.75rem",
          fontWeight: 300,
          color: theme.palette.text.primary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
        },
        titleContainer: {
          height: "100%",
          padding: theme.spacing(0.875, 1.625, 0),
          maxWidth: "204px",
        },
        detailWrapper: {
          height: "100%",
          justifyContent: "space-between",
          padding: theme.spacing(0, 1.25, 1.25, 0),
        },
        locationInfoContainer: {
          paddingLeft: theme.spacing(1.625),
          paddingBottom: theme.spacing(0.875),
          color: theme.palette.text.secondary,
        },
        boothText: {
          overflow: "hidden",
          fontSize: "0.75rem",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "none",
        },
        chip: {
          backgroundColor: theme.palette.grey[300],
          fontSize: "0.75rem",
          fontWeight: 400,
          borderRadius: "4px",
          height: "20px",
          padding: theme.spacing(0.5),
          "& .MuiChip-label": {
            padding: theme.spacing(0),
          },
        },
        newShopChip: {
          display: "none",
        },
        comingSoonChip: {
          display: "none",
        },
        titleWrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
      },
    },
    DirectorySkeletonCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          display: "flex",
          height: "96px",
          borderRadius: "8px",
        },
        avatar: {
          boxShadow: theme.shadows[1],
          height: "100%",
          width: "100%",
          maxWidth: "96px",
        },
        logo: {
          boxShadow: "none",
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
          padding: theme.spacing(0.875, 1.625),
        },
        divider: {
          display: "none",
          height: "1px",
          margin: theme.spacing(0, 1.625),
        },
        primaryText: {
          fontSize: "1rem",
        },
        secondaryText: {
          fontSize: "0.875rem",
        },
      },
    },
    PromotionPage: {
      defaultProps: {
        promotionCarouselOption: {
          limitPaginations: 7,
          /**
           * NOTE:
           * `gap`: gap between carousel items
           * `fixedWidth`: width of each carousel item
           */
        },
      },
      styleOverrides: {
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: theme.spacing(4),
          // add space for scrollbar
          paddingRight: theme.spacing(2),
          paddingBottom: theme.spacing(4),
        },
        pageCard: {
          backgroundColor: theme.palette.background.paper,
        },
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: theme.spacing(2.5),
          "&.PromotionLayoutType-carousel": {
            padding: theme.spacing(3, 0),
            "&:after": {
              display: "none",
            },
          },
          "&.PromotionLayoutType-grid": {
            padding: theme.spacing(3, 12, 0, 12),
          },
          "&.PromotionDisplayMode-grouped": {
            "&.PromotionLayoutType-grid": {
              padding: theme.spacing(3, 12),
            },
            "& .VerticalEventCard-comingSoonChip": {
              display: "none",
            },
            "&:after": {
              bottom: 120,
            },
          },
        },
        carouselContainer: {
          position: "relative",
          top: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            left: 0,
            zIndex: 1,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            right: 0,
            zIndex: 1,
          },
        },
        carousel: {
          width: "100%",
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            width: "20px",
            height: "20px",
            backgroundColor: theme.palette.primary.main,
            borderRadius: 30,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
          },
          "& .splide__track": {
            margin: 0,
            padding: theme.spacing(0, 3.75, 1.5, 3.75),
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "scale(1)",
              opacity: 1,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        promotionCard: {},
        // TODO: will style with all empty page
        emptyDataWrapper: {
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 0,
        },
        venueSelector: {
          display: "none",
          position: "absolute",
          zIndex: 1,
          left: "50%",
          bottom: "-2px",
          transform: "translate(-50%, -50%)",
        },
        promotionGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          "& .MuiToggleButton-root": {
            padding: theme.spacing(2, 4),
            height: "80px",
            width: "220px",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1.5),
            borderRadius: "24px",
            paddingLeft: theme.spacing(2),
            margin: "0 auto",
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: 0,
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
          "& .MuiTypography-root": {
            fontSize: "1.2rem",
            fontWeight: 400,
            lineHeight: "120%",
          },
        },
      },
    },
    PromotionDetailPage: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
    VerticalPromotionCard: {
      styleOverrides: {
        root: {
          "&.FeatureGridLayout": {
            "& .VerticalCard-cardContent": {
              height: "152px",
              "& .VerticalCard-venueLogoContainer": {
                bottom: "12px",
                right: "12px",
                "& .MuiCardMedia-root": {
                  maxHeight: "22px",
                },
              },
              "& .VerticalCard-highlightChip": {
                height: "20px",
                padding: theme.spacing(0.5, 1),
                "& .MuiChip-label": {
                  fontSize: "0.7rem",
                },
              },
              "& .VerticalCard-comingSoonChip": {
                height: "20px",
                padding: theme.spacing(0.5, 1),
                "& .MuiChip-label": {
                  fontSize: "0.7rem",
                },
              },
              "& .VerticalCard-durationText": {
                fontSize: "0.7rem",
              },
              "& .VerticalCard-cardTitleText": {
                "&.MuiTypography-root": {
                  fontSize: "0.825rem",
                },
              },
              "& .VerticalCard-iconContainer": {
                width: "16px",
                height: "16px",
                marginRight: theme.spacing(0.5),
              },
              "& .VerticalCard-locationInfo": {
                "&.MuiTypography-root": {
                  fontSize: "0.7rem",
                },
              },
            },
          },
        },
      },
    },
    OccupantPromotionPage: {
      defaultProps: {
        promotionCarouselOption: {},
      },
      styleOverrides: {
        headerContainer: {
          display: "flex",
          flexDirection: "column",
          gap: 2.25,
        },
        headerLogoWrapper: { width: 120 },
        headerLogo: { width: "100%" },
        headerText: {
          fontWeight: 400,
          fontSize: "2rem",
        },
        contentContainer: {
          padding: theme.spacing(4, 10),
          display: "flex",
          flexDirection: "column",
          gap: 7.5,
          height: "100%",
        },
        gridContainer: {
          display: "grid",
          gridAutoRows: "320px",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          columnGap: 5,
          rowGap: theme.spacing(3),
          paddingBottom: theme.spacing(7.5),
          overflowY: "scroll",
          flex: "1 1 1",
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 37.46%, rgba(255, 255, 255, 0.00) 94.07%)",
          },
        },
      },
    },
    FeatureActionContainer: {
      styleOverrides: {
        shortInfoActionWrapper: {
          "button, a": {
            pointerEvents: "all",
          },
          [theme.breakpoints.up("sm")]: {
            paddingBottom: theme.spacing(3),
          },
        },
      },
    },
    EventPage: {
      defaultProps: {
        eventCarouselOption: {
          limitPaginations: 7,
          /**
           * NOTE:
           * `gap`: gap between carousel items
           * `fixedWidth`: width of each carousel item
           */
        },
      },
      styleOverrides: {
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: theme.spacing(4),
          // add space for scrollbar
          paddingRight: theme.spacing(2),
          paddingBottom: theme.spacing(4),
        },
        pageCard: {
          backgroundColor: theme.palette.background.paper,
        },
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: theme.spacing(2.5),
          "&.EventLayoutType-carousel": {
            padding: theme.spacing(3, 0),
            "&:after": {
              display: "none",
            },
          },
          "&.EventLayoutType-grid": {
            padding: theme.spacing(3, 12, 0, 12),
          },
          "&.EventDisplayMode-grouped": {
            "&.EventLayoutType-grid": {
              padding: theme.spacing(3, 12),
            },
            "& .VerticalEventCard-comingSoonChip": {
              display: "none",
            },
            "&:after": {
              bottom: 120,
            },
          },
        },
        carouselContainer: {
          position: "relative",
          top: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            left: 0,
            zIndex: 1,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "100%",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 100%)",
            right: 0,
            zIndex: 1,
          },
        },
        carousel: {
          width: "100%",
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            width: "20px",
            height: "20px",
            backgroundColor: theme.palette.primary.main,
            borderRadius: 30,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
          },
          "& .splide__track": {
            margin: 0,
            padding: theme.spacing(0, 3.75, 1.5, 3.75),
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "scale(1)",
              opacity: 1,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        // TODO: will style with all empty page
        emptyDataWrapper: {
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 0,
        },
        venueSelector: {
          display: "none",
          position: "absolute",
          zIndex: 1,
          left: "50%",
          bottom: "-2px",
          transform: "translate(-50%, -50%)",
        },
        eventGroupSelectorButton: {
          display: "flex",
          justifyContent: "center",
          "& .MuiToggleButton-root": {
            padding: theme.spacing(2, 4),
            height: "80px",
            width: "220px",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1.5),
            borderRadius: "24px",
            paddingLeft: theme.spacing(2),
            margin: "0 auto",
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: 0,
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: 0,
          },
          "& .MuiTypography-root": {
            fontSize: "1.2rem",
            fontWeight: 400,
            lineHeight: "120%",
          },
        },
      },
    },
    EventDetailPage: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
    // TODO: will change to className selectors when refactor `VerticalEventCard`
    VerticalEventCard: {
      styleOverrides: {
        root: {
          "&.FeatureGridLayout": {
            "& .VerticalCard-cardContent": {
              height: "152px",
              "& .VerticalCard-venueLogoContainer": {
                bottom: "12px",
                right: "12px",
                "& .MuiCardMedia-root": {
                  maxHeight: "22px",
                },
              },
              "& .VerticalCard-highlightChip": {
                height: "20px",
                padding: theme.spacing(0.5, 1),
                "& .MuiChip-label": {
                  fontSize: "0.7rem",
                },
              },
              "& .VerticalCard-comingSoonChip": {
                height: "20px",
                padding: theme.spacing(0.5, 1),
                "& .MuiChip-label": {
                  fontSize: "0.7rem",
                },
              },
              "& .VerticalCard-durationText": {
                fontSize: "0.7rem",
              },
              "& .VerticalCard-cardTitleText": {
                "&.MuiTypography-root": {
                  fontSize: "0.825rem",
                },
              },
              "& .VerticalCard-iconContainer": {
                width: "16px",
                height: "16px",
                marginRight: theme.spacing(0.5),
              },
              "& .VerticalCard-locationInfo": {
                "&.MuiTypography-root": {
                  fontSize: "0.7rem",
                },
              },
            },
          },
        },
      },
    },
    VerticalCard: {
      styleOverrides: {
        root: {
          width: "100%",
          borderRadius: "24px",
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.grey[200]}`,
          display: "flex",
          flexDirection: "column",
          boxShadow:
            "0 16px 5px 0 rgba(0, 0, 0, 0.00), 0 11px 4px 0 rgba(0, 0, 0, 0.01), 0 6px 4px 0 rgba(0, 0, 0, 0.02), 0 3px 3px 0 rgba(0, 0, 0, 0.03), 0 1px 1px 0 rgba(0, 0, 0, 0.04)",
        },
        cardMedia: {
          height: "100%",
          aspectRatio: theme.mixins?.cardRatio?.aspectRatio,
          objectFit: "cover",
          position: "relative",
        },
        cardContent: {
          padding: theme.spacing(2),
          gap: theme.spacing(1),
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "190px",
          "&.MuiCardContent-root:last-child": {
            padding: theme.spacing(2),
          },
          "& .MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        cardContentStack: {
          gap: theme.spacing(1),
        },
        venueLogoContainer: {
          display: "none",
          position: "absolute",
          bottom: "16px",
          right: "16px",
          "& .MuiCardMedia-root": {
            maxWidth: "90px",
            maxHeight: "43px",
          },
        },
        venueLogo: {},
        chipContainer: {
          display: "flex",
          gap: theme.spacing(0.5),
        },
        highlightChip: {},
        comingSoonChip: {},
        durationContainer: {},
        duration: {
          color: theme.palette.text.secondary,
        },
        cardTitle: {
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          "&.MuiTypography-root": {
            color: theme.palette.grey[800],
            fontSize: "1.25rem",
            fontWeight: 700,
            lineHeight: "112%",
          },
        },
        cardInfoContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "end",
          "& .MuiTypography-root": {
            color: theme.palette.text.secondary,
            fontSize: "1rem",
          },
        },
        iconContainer: {
          width: "24px",
          height: "24px",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            color: theme.palette.grey[600],
            width: "100%",
            height: "auto",
          },
        },
        locationInfo: {},
        recommendTextContainer: {
          display: "none",
        },
        recommendText: {},
      },
    },
    ImageCard: {
      styleOverrides: {
        root: {},
        chipContainer: {
          position: "absolute",
          padding: "3%",
          right: 0,
          top: 0,
          zIndex: 1,
        },
        chip: {
          height: "30px",
          padding: theme.spacing(0.75, 1),
          fontSize: "0.875rem",
          fontWeight: 500,
          backgroundColor: theme.palette.error.main,
          borderRadius: "50px",
          color: theme.palette.error.contrastText,
        },
      },
    },
    ImageSkeletonCard: {
      styleOverrides: {
        root: {
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
        },
      },
    },
    HighlightFeatureCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          display: "flex",
          flexDirection: "row",
          height: 136,
          padding: theme.spacing(1.5, 1.375),
        },
        cardMedia: {
          width: 74,
          maxHeight: 164,
          borderRadius: "5px",
          objectFit: "cover",
          [theme.breakpoints.up("sm")]: {
            width: 95,
          },
        },
        cardContent: {
          padding: theme.spacing(1.375, 0, 1.375, 3),
          "&:last-child": {
            paddingBottom: theme.spacing(1),
            [theme.breakpoints.up("sm")]: {
              padding: theme.spacing(1, 1, 1, 3),
            },
          },
        },
        contentWrapper: {
          height: "100%",
          justifyContent: "space-between",
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        cardInfoItem: {
          display: "flex",
          flexDirection: "row",
          color: theme.palette.text.secondary,
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
        },
        iconWrapper: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: 14,
            color: theme.palette.primary.main,
          },
        },
      },
    },
    ListPromotionItemCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          display: "flex",
          flexDirection: "row",
          height: 104,
          padding: theme.spacing(1, 0.5),
        },
        cardMedia: {
          width: 88,
          maxHeight: 88,
          borderRadius: "5px",
          objectFit: "cover",
          [theme.breakpoints.up("sm")]: {
            width: 95,
          },
        },
        cardContent: {
          padding: theme.spacing(0.5, 1, 0.5, 2),
          "&:last-child": {
            paddingBottom: theme.spacing(0.5),
            [theme.breakpoints.up("sm")]: {
              padding: theme.spacing(0.5, 1, 0.5, 2),
            },
          },
        },
        contentWrapper: {
          height: "100%",
          gap: theme.spacing(2),
          justifyContent: "space-between",
        },
        cardTitle: {
          fontWeight: 600,
          fontSize: "14px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        promotionInfoItem: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.text.secondary,
          "& .MuiTypography-root": {
            fontSize: "0.75rem",
            fontWeight: 400,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
          },
        },
        iconWrapper: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: 16,
            color: "inherit",
          },
        },
      },
    },
    ListPrivilegeItemCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: "8px",
          padding: theme.spacing(1),
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(2),
          "& .MuiSvgIcon-root": {
            color: theme.palette.grey[500],
            width: 16,
            height: 16,
          },
        },
        label: {
          color: theme.palette.text.secondary,
          fontWeight: 600,
        },
      },
    },
    FeatureSummary: {
      styleOverrides: {
        root: {},
        container: {
          display: "flex",
          gap: theme.spacing(2),
          boxShadow: "none",
        },
        logoContainer: {
          width: "60px",
          height: "60px",
        },
        infoSection: {},
        infoContainer: {},
        title: {
          marginBottom: theme.spacing(1),
        },
        endAdornment: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          width: "80px",
          height: "80px",
          paddingLeft: theme.spacing(2),
          "&:after": {
            content: "''",
            position: "absolute",
            width: "1px",
            top: 0,
            left: 0,
            bottom: 0,
            backgroundColor: theme.palette.grey[500],
            marginTop: theme.spacing(1.25),
            marginBottom: theme.spacing(1.25),
          },
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: "subtitle1" },
          style: {
            lineHeight: 1.4,
          },
        },
      ],
    },
    DirectionStepItem: {
      styleOverrides: {
        root: {
          "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(4),
          },
          "&:first-of-type": {
            "& .MuiListItemText-primary": {
              fontWeight: 700,
            },
          },
          "&:last-of-type": {
            "& .MuiListItemText-primary": {
              fontWeight: 600,
            },
            "& .MuiStepLabel-iconContainer": {
              paddingLeft: theme.spacing(0.5),
              paddingRight: theme.spacing(3),
            },
          },

          "& .MuiStepIcon-root": {
            width: 37,
            height: 37,
            "& .MuiStepIcon-text": {
              fontSize: theme.typography.caption.fontSize,
            },
          },
          "& .MuiStepLabel-vertical": {
            padding: 0,
          },
        },
        listItem: {
          "& .MuiListItemText-primary": {
            whiteSpace: "normal",
            color: theme.palette.text.primary,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.subtitle2.fontWeight,
          },
          "& .MuiListItemText-secondary": {
            fontSize: "0.75rem",
          },
          "& .MuiListItemSecondaryAction-root": {
            marginLeft: "auto",
            position: "static",
            transform: "none",
            color: theme.palette.text.secondary,
            right: 0,
          },
        },
      },
    },
    EmptyData: {
      styleOverrides: {
        root: {
          width: "100%",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "192px",
            height: "192px",
            color: theme.palette.grey[500],
          },
        },
        primaryText: {
          fontSize: "2rem",
          fontWeight: 700,
        },
        secondaryText: {
          color: theme.palette.grey[500],
          fontSize: "1.5rem",
          marginTop: theme.spacing(2),
        },
        iconWrapper: {
          marginBottom: theme.spacing(5),
        },
      },
    },
    NewShopsPage: {
      styleOverrides: {
        filterSection: {
          margin: theme.spacing(0, -3),
        },
        filterContainer: {
          paddingLeft: 0,
          paddingBottom: 3,
        },
        filterButton: {
          whiteSpace: "nowrap",
          gap: theme.spacing(2),
          "& .MuiSvgIcon-root": {
            marginRight: theme.spacing(1),
          },
          ":first-of-type": {
            marginLeft: theme.spacing(3),
          },
        },
        newShopAvatarFallBack: {},
        newShopImageCard: {
          display: "block",
          width: "235px",
          height: "235px",
          "& .MuiCardActionArea-root, & .MuiCardMedia-root": {
            height: "100%",
            width: "100%",
          },
          "& .MuiCardHeader-root": {
            padding: theme.spacing(2),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignSelf: "stretch",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
            fontWeight: 700,
          },
          "& .MuiCardHeader-subheader": {
            fontWeight: 400,
            "& .sub-category-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
            "& .booth-name-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
          },
          "&.no-image": {
            "& .MuiCardActionArea-root:after": {},
          },
          "& .MuiChip-root": {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
          },
          "& .MuiCardHeader-root .MuiCardHeader-avatar": {
            marginRight: theme.spacing(2),
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "64px",
            height: "64px",
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
        },
        newShopFallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.common.white,
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        newShopFallbackImageIcon: {
          height: "64px",
          width: "64px",
          zIndex: 1,
        },
        comingSoonShopAvatarFallBack: {},
        comingSoonShopImageCard: {
          display: "block",
          width: "235px",
          height: "235px",
          "& .MuiCardActionArea-root, & .MuiCardMedia-root": {
            height: "100%",
            width: "100%",
          },
          "& .MuiCardHeader-root": {
            padding: theme.spacing(2),
          },
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-content": {
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignSelf: "stretch",
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
            fontWeight: 700,
          },
          "& .MuiCardHeader-subheader": {
            fontWeight: 400,
            "& .sub-category-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
            "& .booth-name-text": {
              overflow: "hidden",
              fontSize: "0.75rem",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "90%",
              display: "none",
            },
          },
          "& .MuiCardActionArea-root:after": {
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.5) -50%, rgba(0, 0, 0, 0.90) 100%)",
          },
          "&.no-image": {
            "& .MuiCardActionArea-root:after": {
              background: "linear-gradient(180deg, #FFF -41.34%, #000 99.92%)",
            },
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "64px",
            height: "64px",
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
          "& .MuiChip-root": {
            backgroundColor: theme.palette.grey[300],
            color: theme.palette.grey[500],
          },
        },
        comingSoonShopFallbackImageIconWrapper: {
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
          color: theme.palette.grey[400],
          height: "100%",
          width: "100%",
          background: theme.palette.grey[500],
          paddingTop: "30%",
        },
        comingSoonShopFallbackImageIcon: {
          height: "64px",
          width: "64px",
          zIndex: 1,
        },
        venueSelector: {
          position: "fixed",
          bottom: "175px",
          right: "690px",
          zIndex: 2,
        },
        contentWrapper: {
          height: "100%",
        },
        emptyDataWrapper: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "370px",
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridAutoRows: "max-content",
          gridTemplateColumns: "repeat(auto-fill, minmax(235px, 1fr))",
          gap: theme.spacing(3),
          paddingBottom: theme.spacing(8.75),
          overflowY: "auto",
          height: "100%",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "&.emptyList": {},
        },
        gridItem: {
          height: "230px",
        },
        pageCard: {
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 2.8%, rgba(255, 255, 255, 0.00) 50%)",
          },
        },
      },
    },
    OccupantCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          borderRadius: "10px",
          width: "100%",
        },
        cardTitle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          color: theme.palette.text.primary,
          wordBreak: "break-word",
        },
        cardMediaWrapper: {
          position: "relative",
        },
        cardMedia: {
          height: "180px",
        },
        cardContent: {
          padding: theme.spacing(1.5, 2),
          "&:last-child": {
            paddingBottom: theme.spacing(1),
          },
        },
      },
    },
    UserLocationListItem: {
      styleOverrides: {
        icon: {
          background: "transparent",
          color: theme.palette.text.primary,
          fontSize: "3rem",
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
        },
      },
    },
    FeatureListItem: {
      defaultProps: {
        boothNameTextSeparator: " | ",
        locationTextSeparator: " | ",
      },
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
        },
        adornmentWrapper: {
          display: "none",
          flexDirection: "row",
          height: "55px",
        },
        adornmentMedia: {
          objectFit: "contain",
          maxWidth: "60px",
          maxHeight: "55px",
        },
        adornmentDivider: {
          marginLeft: theme.spacing(3),
          marginRight: theme.spacing(2),
          borderRight: "1px solid rgba(203, 203, 203, 0.5)",
        },
        adornmentTextAvatar: {
          width: 32,
          height: 32,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          minWidth: 32,
          borderRadius: "50%",
          display: "none",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "0.75rem",
        },
        bottomDivider: {
          borderBottom: "1px solid rgba(203, 203, 203, 0.5)",
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
        },
        listItemText: {
          "& .MuiListItemText-primary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.4,
            wordBreak: "break-all",
          },
          "& .MuiListItemText-secondary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.4,
          },
        },
        listItemAvatar: {
          "& .MuiAvatar-root": {
            fontSize: "2.275rem",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
        },
        boothNameText: {
          display: "none",
        },
        venueText: {
          display: "none",
        },
        categoryText: {
          display: "none",
        },
        sponsoredChip: {
          display: "none",
        },
      },
    },
    DirectionSearchContainer: {
      styleOverrides: {
        wrapper: {
          width: "100%",
          [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
          },
        },
        suggestionList: {
          marginTop: theme.spacing(8),
          // direction search box = 108 px
          // avoid step button 32 px + top-bottom margin 16px * 2 = 64px
          // top-bottom page layout padding 24px * 2 = 48px
          maxHeight: `calc(100vh - 220px)`,
          overflow: "auto",
          background: theme.palette.background.paper,
          boxShadow: theme.shadows[1],
          position: "absolute",
          zIndex: theme.zIndex.drawer + 1,
          borderRadius: "10px",
          //left-right layout padding = 24 * 2 = 48px
          width: `calc(100vw - 48px)`,
          [theme.breakpoints.up("sm")]: {
            //left-right layout padding = 24 * 2 = 48px
            maxWidth: mixins.mobileDirectionSearch.width - 48,
          },
        },
      },
    },
    AppOrdinalSelector: {
      styleOverrides: {
        root: {
          width: "80px",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: theme.palette.background.paper,
          boxShadow:
            "0 50px 14px 0 rgba(0, 0, 0, 0.00), 0 32px 13px 0 rgba(0, 0, 0, 0.01), 0 18px 11px 0 rgba(0, 0, 0, 0.05), 0 8px 8px 0 rgba(0, 0, 0, 0.09), 0 2px 4px 0 rgba(0, 0, 0, 0.10)",
        },
        ordinalList: {
          padding: theme.spacing(1),
          gap: theme.spacing(0.5),
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        listItemButton: {
          width: 72,
          height: 72,
          justifyContent: "center",
          borderRadius: "12px",
          backgroundColor: theme.palette.background.paper,
          fontSize: "1.25rem",
          transition: `color ${theme.transitions.duration.short}ms ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} , background - color ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} `,
          fontWeight: theme.typography.fontWeightBold,
          color: theme.palette.text.primary,
          padding: theme.spacing(2),
          ":hover": {
            backgroundColor: theme.palette.primary.main,
          },
          "&.Mui-selected": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            opacity: 1,
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        ordinalSelectorTitle: {
          display: "none",
        },
      },
    },
    AppPageCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          height: "100%",
          boxShadow: "none",
        },
      },
    },
    AppPageCardContent: {
      styleOverrides: {
        root: {
          height: "100%",
          padding: theme.spacing(3, 4),
        },
      },
    },
    LanguageButton: {
      defaultProps: {
        MenuProps: {
          transformOrigin: { horizontal: "center", vertical: "bottom" },
          anchorOrigin: { horizontal: "center", vertical: "top" },
        },
      },
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none",
          },
        },
        menuPaper: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            marginLeft: theme.spacing(-0.5),
            marginRight: theme.spacing(1),
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            bottom: 0,
            left: `50 % `,
            width: `10px`,
            height: `10px`,
            backgroundColor: theme.palette.background.paper,
            transform: "translate(-50%, 50%) rotate(45deg)",
            zIndex: 0,
          },
        },
        label: {},
        avatar: {
          width: "24px",
          height: "24px",
          padding: "2px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.10)",
          "&> img": {
            borderRadius: 9999,
          },
        },
        secondaryLabel: { display: "none" },
        labelContainer: {},
      },
    },
    AppQRCode: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "transparent",
          boxShadow: "none",
          position: "relative",
          padding: theme.spacing(0.5),
          width: 80,
          height: 80,
          "&:before,:after, .MuiCardContent-root:before, .MuiCardContent-root:after":
            {
              display: "block",
              content: '""',
              width: "20px",
              height: "20px",
              position: "absolute",
            },
          "&:before": {
            top: 0,
            left: 0,
            borderTop: `3px solid ${theme.palette.common.black} `,
            borderLeft: `3px solid ${theme.palette.common.black} `,
            borderRadius: "3px",
          },
          "&:after": {
            bottom: 0,
            left: 0,
            borderBottom: `3px solid ${theme.palette.common.black} `,
            borderLeft: `3px solid ${theme.palette.common.black} `,
            borderRadius: "3px",
          },
          "& .MuiCardContent-root:before": {
            top: 0,
            right: 0,
            borderTop: `3px solid ${theme.palette.common.black} `,
            borderRight: `3px solid ${theme.palette.common.black} `,
            borderRadius: "3px",
          },
          "& .MuiCardContent-root:after": {
            bottom: 0,
            right: 0,
            borderBottom: `3px solid ${theme.palette.common.black} `,
            borderRight: `3px solid ${theme.palette.common.black} `,
            borderRadius: "3px",
          },
          "& .MuiCardContent-root": {
            border: "none",
            height: 80,
            width: 80,
            "&:last-child": {
              paddingBottom: theme.spacing(0.5),
            },
          },
        },
        qrCodeContent: {
          display: "flex",
          borderRadius: "8px",
          border: `5px solid ${theme.palette.primary.main} `,
          padding: theme.spacing(0.5),
        },
        qrCodeCaption: {
          fontSize: "1rem",
          paddingTop: theme.spacing(1.5),
        },
        qrCodeSecondaryCaption: {
          lineHeight: 1,
        },
        qrCode: {
          width: "100%",
          height: "100%",
          border: "4px solid #fff",
        },
      },
    },
    AppDetailPage: {
      defaultProps: {
        locationTextKeys: ["floorText"],
        locationSeparator: " | ",
        locationEmpty: "-",
        promotionCarouselOption: {
          limitPaginations: 7,
        },
      },
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        avatarRoot: {
          margin: 0,
          width: "80px",
          height: "80px",
          borderRadius: "8px",
          fontSize: "3rem",
          boxShadow: `0px 8px 24px 0px rgba(155, 155, 155, 0.15)`,
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        titleText: {
          fontWeight: 700,
        },
        captionText: {
          color: theme.palette.text.secondary,
          fontWeight: 700,
        },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: theme.spacing(0, 3.75),
          flexGrow: 1,
          gap: theme.spacing(1),
        },
        headerContainer: {
          display: "flex",
          flexDirection: "column",
          paddingTop: theme.spacing(4),
          gap: theme.spacing(1.5),
          alignItems: "center",
        },
        titleContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        tabsContainer: {
          width: "364px",
          display: "flex",
          justifyContent: "center",
        },
        placeDetailTabs: {
          width: "100%",
          "&.MuiTabs-root": {
            minHeight: "35px",
          },
        },
        placeDetailTab: {
          flex: 1,
          "&.MuiButtonBase-root": {
            minHeight: "35px",
            padding: theme.spacing(0),
            fontSize: "1rem",
          },
          color: theme.palette.grey[600],
          "&.Mui-selected": {
            color: theme.palette.primary,
          },
          "&.Mui-disabled": {
            color: theme.palette.grey[300],
          },
        },
        descriptionText: {
          height: 100,
          color: theme.palette.text.secondary,
          overflowY: "auto",
          fontSize: "0.875rem",
          lineHeight: 1.5,
          width: "100%",
          marginBottom: theme.spacing(1),
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "::-webkit-scrollbar-track": {
            borderRadius: "8px",
            background: theme.palette.grey[300],
          },
          "::-webkit-scrollbar-thumb": {
            borderRadius: "8px",
            background: theme.palette.primary.main,
          },
          "::-webkit-scrollbar-thumb:hover": {
            background: theme.palette.primary.main,
          },
        },
        locationContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(2),
          height: "139px",
        },
        locationDetail: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
          "& .MuiListItem-root": {
            padding: 0,
          },
          "& .MuiListItemText-root": {
            gap: theme.spacing(1),
            display: "flex",
            flexDirection: "column",
            textTransform: "uppercase",
            margin: 0,
          },
          "& .MuiListItemText-primary": {
            color: theme.palette.text.secondary,
            fontWeight: 400,
            fontSize: "1rem",
          },
          "& .MuiListItemText-secondary": {
            color: theme.palette.text.primary,
            fontWeight: 700,
            fontSize: "1.125rem",
          },
        },
        buildingLogo: {
          height: "50px",
          marginLeft: theme.spacing(5),
          "& img": {
            width: "100%",
            height: "100%",
          },
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          marginTop: "auto",
          width: "100%",
        },
        stretchButton: {
          height: "43px",
          width: "100%",
          textTransform: "capitalize",
        },
        locationDetailIcon: {
          color: theme.palette.secondary.main,
        },
        locationDetailContainer: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        locationTextContainer: {},
        categoryTextContainer: {},
        locationText: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-all",
        },
        qrCodeContainer: {
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        qrcodeText: {
          textTransform: "uppercase",
          fontSize: "0.625rem",
        },
        galleryCarouselImage: {
          width: "100%",
          height: "192px",
          objectFit: "cover",
          borderRadius: "10px",
        },
        galleryCarouselItem: {},
        galleryCarousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
            borderRadius: "10px",
          },
          "& .splide__pagination__page": {
            marginTop: theme.spacing(1.5),
            width: "8px",
            height: "8px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.secondary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: "47.25px",
            borderRadius: "35px",
          },
        },
        galleryCarouselWrapper: {
          width: "100%", //Prevent unexpected slide displays in SplideJS.
        },
        promotionCarouselWrapper: {
          width: "100%",
          marginBottom: theme.spacing(-1),
        },
        promotionCarousel: {
          "& .splide__slide": {
            padding: theme.spacing(0.5),
          },
          "& .splide__track": {
            margin: theme.spacing(0),
            padding: theme.spacing(0),
          },
          "& .splide__pagination__page": {
            marginTop: theme.spacing(1.5),
            width: "8px",
            height: "8px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.secondary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
            width: "47.25px",
            borderRadius: "35px",
          },
        },
        promotionCarouselItem: {},
        promotionCard: {
          minHeight: "370px",
          width: "100%",
          "& .MuiCardMedia-root": {
            maxHeight: "340px",
            height: "370px",
          },
          "& .PromotionCard-cardContent": {
            flex: 1,
          },
        },
        sidebarContent: {},
      },
    },
    OrdinalSelectMenu: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          height: "56px",
          width: "171px",
          textAlign: "center",
          borderRadius: "9999px",
          boxShadow: "0px 4px 14px 0px rgba(0, 0, 0, 0.20)",
          "&.Mui-focused": {
            border: "none",
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "& svg": {
              color: theme.palette.primary.contrastText,
            },
          },
          "& .MuiSelect-select.MuiInputBase-input": {
            paddingTop: theme.spacing(1.75),
            paddingBottom: theme.spacing(1.75),
            paddingLeft: theme.spacing(2.5),
            fontSize: "1.5rem",
            minHeight: "unset",
          },
        },
        paper: {
          backgroundColor: "transparent",
          boxShadow: "none",
          alignItems: "center",
          maxHeight: "35vh",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
        },
        menuList: {
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        },
        menuItem: {
          margin: theme.spacing(1),
          backgroundColor: theme.palette.background.paper,
          borderRadius: "50%",
          height: "48px",
          width: "48px",
          padding: 0,
          minHeight: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transformOrigin: "top center",
          animation: `slideUp 300ms ease -in -out forwards`,
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.contrastText} `,
            color: theme.palette.primary.contrastText,
            ":hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          ":hover": {
            backgroundColor: theme.palette.primary.main,
          },
        },
        text: {
          fontSize: "1.25rem",
          textTransform: "uppercase",
          letterSpacing: "1px",
          color: theme.palette.text.secondary,
        },
      },
    },
    VenueSelector: {
      styleOverrides: {
        root: {
          gap: theme.spacing(3),
        },
        buttonWrapper: {
          display: "flex",
          justifyContent: "center",
          transition: `transform ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn} `,
          "&.selected": {
            transform: "scale(1.77)",
            marginLeft: theme.spacing(3),
            marginRight: theme.spacing(3),
          },
        },
        button: {
          width: 70,
          height: 70,
          padding: 0,
          backgroundColor: theme.palette.primary.main,
          borderRadius: "50%",
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            ":hover": {
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        allVenueIcon: {
          width: "100%",
          height: "100%",
        },
        icon: {
          width: "100%",
          height: "100%",
        },
        currentVenueChip: {
          width: "48px",
          height: "12px",
          position: "absolute",
          bottom: "-4px",
        },
        allVenueLabel: {
          display: "none",
        },
      },
    },
    SwitchVenueStep: {
      styleOverrides: {
        root: {
          gap: theme.spacing(5),
          flexDirection: "row",
          alignItems: "center",
        },
        venueLogo: { height: "65px", width: "143px", objectFit: "contain" },
        iconContainer: {
          height: "100%",
          display: "flex",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "40px",
            height: "40px",
            "& .primary": {
              fill: theme.palette.primary.main,
            },
          },
        },
      },
    },
    BorderLinearProgress: {
      styleOverrides: {
        root: {
          position: "relative",
          width: "100%",
          "&:after": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            content: "''",
            display: "block",
            height: 4,
            width: "100%",
            borderRadius: 5,
            backgroundColor: theme.palette.grey[300],
            right: 0,
          },
        },
        linearProgress: {
          height: 20,
          borderRadius: 15,
          zIndex: 1,
          ":after": {
            position: "absolute",
            zIndex: 5,
            top: "50%",
            transform: "translateY(-50%)",
            height: 4,
            content: "''",
            display: "block",
          },
          "&.MuiLinearProgress-colorPrimary": {
            backgroundColor: "transparent",
            "&.Mui-start": {
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":after": {
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              content: "''",
              display: "inline-block",
              width: 14,
              height: 14,
              borderRadius: "50%",
              backgroundColor: theme.palette.grey[300],
              zIndex: 1,
              left: 0,
            },
            "&.Mui-complete": {
              ":before": {
                backgroundColor: theme.palette.primary.main,
              },
              ":after": {
                backgroundColor: theme.palette.primary.main,
              },
            },
            ":before": {
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              content: "''",
              display: "inline-block",
              width: 14,
              height: 14,
              borderRadius: "50%",
              backgroundColor: theme.palette.grey[300],
              zIndex: 1,
              right: 0,
            },
          },
          "& .MuiLinearProgress-bar": {
            margin: "auto 0",
            height: 4,
            borderRadius: 5,
            backgroundColor: theme.palette.primary.main,
            boxShadow: `0px 0px 10px ${theme.palette.primary.main} `,
          },
        },
      },
    },
    VerticalLinearProgress: {
      styleOverrides: {
        root: {
          height: "186px",
          margin: theme.spacing(1.25, 0),
        },
        slider: {
          color: theme.palette.primary.main,
          width: "3px",
          borderRadius: 0,
          "& .MuiSlider-thumb": {
            width: "21px",
            height: "21px",
            transition: `bottom ${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeInOut} `,
            "&.Mui-focusVisible": {
              boxShadow: "none",
            },
          },
          "& .MuiSlider-rail": {
            color: theme.palette.grey[300],
            opacity: 1,
          },
          "& .MuiSlider-track": {
            boxShadow: `0px 0px 10px ${theme.palette.primary.main} `,
            borderWidth: 0,
            transition: `height ${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeInOut} `,
          },
          '& input[type="range"]': {
            WebkitAppearance: "slider-vertical",
          },
        },
      },
    },
    CategoryQuickSearch: {
      styleOverrides: {
        categoryFilterBarContainer: {
          position: "relative",
          order: 1,
        },
        scrollPane: {
          padding: 0,
        },
        categoryFilterBar: {
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            display: "none",
          },
          "& .highlight .MuiSvgIcon-root": {
            display: "block",
          },
        },
        categoryFilterChip: {
          "& .CategoryFilterChip-icon": {
            display: "none",
          },
        },
      },
    },
    MapUpdateLoadingScreen: {
      styleOverrides: {
        backdrop: {
          zIndex: theme.zIndex.modal,
        },
        container: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(1),
          color: theme.palette.primary.main,
        },
      },
    },
    StepByStepIcon: {
      defaultProps: {
        waveColor: theme.palette.primary.main,
      },
      styleOverrides: {},
    },
    VerticalStepProgressBar: {
      styleOverrides: {
        wrapper: {
          height: "100%",
          padding: theme.spacing(1),
          marginTop: 0,
        },
        stepperContainer: {
          height: "100%",
          overflowY: "scroll",
        },
        stepper: {
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          zIndex: 1,
          "& .MuiButtonBase-root": {
            display: "none",
          },
          "& .MuiStepLabel-root": {
            padding: 0,
          },
          "& .MuiStepLabel-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            position: "relative",
            padding: 0,
            fontSize: "1rem",
            lineHeight: 1.2,
          },
          "& .MuiStepLabel-iconContainer": {
            paddingRight: theme.spacing(1.25),
            "&:last-child": {
              paddingRight: 0,
            },
          },
          "& .step": {
            backgroundColor: theme.palette.grey[500],
            width: "40px",
            height: "40px",
            fontSize: "1.25rem",
            "& svg": {
              width: "20px",
              height: "20px",
            },
          },
          "&.originStep": {
            visibility: "visible",
            "& .MuiStepLabel-label": {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: theme.spacing(1),
            },
          },
          "&.destinationStep": {
            "& .MuiStepLabel-label": {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: theme.spacing(1),
            },
            "& .MuiBox-root": {
              width: "40px",
              height: "40px",
            },
            "& .MuiSvgIcon-root": {
              visibility: "visible",
              width: "40px",
              height: "40px",
              background: theme.palette.common.white,
            },
          },
          "& .Mui-active, & .Mui-completed": {
            "& .step:not(.originStep,.StepByStepIcon-destination)": {
              backgroundColor: theme.palette.primary.main,
            },
          },
          "& .StepByStepIcon-destination": {
            width: "28px",
            height: "28px",
          },
        },
        originIcon: {
          "&.MuiSvgIcon-root": {
            height: "28px",
            width: "28px",
            fill: theme.palette.primary.main,
          },
        },
        connector: {
          marginLeft: theme.spacing(2.25),
          "& .MuiStepConnector-line": {
            background: "transparent",
            borderLeft: `4px dotted ${theme.palette.grey[300]}`,
            width: "4px",
            minHeight: "86px",
            height: "calc(100% + 40px)",
            margin: theme.spacing(-2.5, 0),
          },
          "&.Mui-active": {
            "& .MuiStepConnector-line": {
              background: "transparent",
              borderLeft: `4px solid ${theme.palette.primary.main}`,
            },
          },
          "&.Mui-completed": {
            "& .MuiStepConnector-line": {
              background: "transparent",
              borderLeft: `4px solid ${theme.palette.primary.main}`,
            },
          },
          "&.MuiStepConnector-vertical": {},
        },
      },
    },
    SuggestionListItem: {
      defaultProps: {},
    },
    LanguageButtonMenu: {
      styleOverrides: {
        wrapper: {
          height: 48,
          display: "flex",
          flexDirection: "row",
          width: "100%",
          padding: theme.spacing(0, 4),
          gap: theme.spacing(3),
        },
        button: {
          borderRadius: "8px",
          border: `1px solid ${theme.palette.primary.main} `,
          flexDirection: "row",
          gap: theme.spacing(1),
          width: 162,
          color: theme.palette.primary.main,
          "& .MuiBottomNavigationAction-label": {
            textTransform: "capitalize",
            fontWeight: 700,
            "&.Mui-selected": {
              fontSize: "1rem",
            },
          },
          "&.Mui-selected": {
            "&:last-of-type": {
              borderTopRightRadius: "8px",
              borderBottomRightRadius: "8px",
            },
            "&:first-of-type": {
              borderTopLeftRadius: "8px",
              borderBottomLeftRadius: "8px",
            },
          },
        },
        avatar: {
          width: "24px",
          height: "24px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.10)",
          "&> img": {
            borderRadius: 9999,
          },
        },
      },
    },
    SkeletonPromotionDetail: {
      styleOverrides: {
        titleText: {
          fontSize: "1.25rem",
        },
        descriptionText: {
          height: "320px",
          margin: theme.spacing(1.5, 4, 0),
        },
        detailContainer: {
          padding: theme.spacing(5, 4, 3),
          height: "100%",
          display: "flex",
          flexDirection: "column",
        },
        locationButton: {
          marginTop: theme.spacing(3),
          width: "100%",
          height: 43,
        },
        qrCode: {
          height: 80,
          width: 80,
        },
        infoListItem: {
          width: 216,
          height: 40,
        },
        locationButtonContainer: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column-reverse",
        },
        listItemContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          padding: theme.spacing(1),
          width: "216px",
        },
        infoContainer: {
          marginTop: theme.spacing(3),
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          padding: theme.spacing(3),
        },
        qrcodeText: {
          marginTop: theme.spacing(1),
          fontSize: "0.75rem",
        },
      },
    },
    SkeletonEventDetailSidebar: {
      styleOverrides: {
        titleText: {
          fontSize: "1.25rem",
        },
        descriptionText: {
          height: "280px",
          margin: theme.spacing(1.5, 4, 0),
        },
        detailContainer: {
          padding: theme.spacing(5, 4, 3),
          height: "100%",
          display: "flex",
          flexDirection: "column",
        },
        locationButton: {
          marginTop: theme.spacing(2),
          width: "100%",
          height: 43,
        },
        qrCode: {
          height: 80,
          width: 80,
        },
        infoListItem: {
          width: 216,
          height: 40,
        },
        locationButtonContainer: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column-reverse",
        },
        listItemContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          padding: theme.spacing(1),
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          padding: theme.spacing(2, 3),
        },
        qrcodeText: {
          marginTop: theme.spacing(1),
          fontSize: "0.75rem",
        },
        gallery: {
          width: "100%",
          height: "170px",
          order: 2,
        },
      },
    },
    AppImageCarouselModal: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(2),
          top: 0,
          bottom: 0,
        },
        carouselContainer: {
          position: "relative",
          outline: "none",
          width: "100%",
        },
        carousel: {
          "& .splide": {
            margin: "0 auto",
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(4.5),
          },
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            transform: "none",
            width: "20px",
            height: "20px",
          },
          "& .splide__track": {
            padding: 0,
          },
          "& .splide__arrow--prev": {
            left: "-1640px",
            "& svg": {
              transform: "unset",
            },
          },
          "& .splide__arrow--next": {
            right: "unset",
          },
        },
        carouselItem: {
          maxWidth: "900px",
        },
        image: {
          margin: "0 auto",
          width: "876px",
          height: "480px",
          borderRadius: "10px",
        },
        carouselArrows: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(3),
          position: "absolute",
          right: theme.spacing(6),
          bottom: "50%",
        },
        prevButton: {
          height: "64px",
          width: "64px",
          borderRadius: "12px",
          backgroundColor: theme.palette.background.default,
          border: "none",
          color: theme.palette.text.secondary,
          transition: "opacity 0.15s ease-in-out",
          "& .MuiSvgIcon-root": {
            width: "30px",
            height: "30px",
          },
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
          "&:disabled": {
            opacity: 0,
            pointerEvents: "none",
          },
        },
        nextButton: {
          height: "64px",
          width: "64px",
          backgroundColor: theme.palette.background.default,
          border: "none",
          borderRadius: "12px",
          color: theme.palette.text.secondary,
          transition: "opacity 0.15s ease-in-out",
          "& .MuiSvgIcon-root": {
            width: "30px",
            height: "30px",
          },
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
          "&:disabled": {
            opacity: 0,
            pointerEvents: "none",
          },
        },
        closeButton: {
          width: "82px",
          height: "82px",
          borderRadius: "24px",
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          position: "absolute",
          zIndex: 9999,
          top: "-20%",
          right: "64px",
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            color: theme.palette.text.secondary,
          },
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        backdrop: {
          top: 0,
          bottom: 0,
        },
      },
    },
    MyLocationButton: {
      styleOverrides: {
        root: {
          height: 80,
          width: 80,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "16px",
          boxShadow:
            "0px 2px 4px 0px rgba(0, 0, 0, 0.1),0px 8px 8px 0px rgba(0, 0, 0, 0.09),0px 18px 11px 0px rgba(0, 0, 0, 0.05),0px 32px 13px 0px rgba(0, 0, 0, 0.01),0px 50px 14px 0px rgba(0, 0, 0, 0)",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
        icon: {
          height: 48,
          width: 48,
          color: theme.palette.text.secondary,
        },
      },
    },
    CarouselNavigation: {
      defaultProps: {
        carouselOption: {},
      },
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
        },
        carousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
        },
        carouselItem: {
          carouselItem: {
            "&.is-active": {
              zIndex: 1,
            },
            "&:not(.is-visible)": {},
            "&.is-move": {},
          },
        },
      },
    },
    CarouselNavigationMenu: {
      styleOverrides: {
        root: {},
      },
    },
    ErrorDialog: {
      styleOverrides: {
        root: {},
        paper: {},
        title: {},
        content: {},
        contentText: {},
        buttonContainer: {},
        button: {},
      },
    },
    CoolDownProgress: {
      styleOverrides: {
        root: {},
        linearProgress: {
          borderRadius: "48px",
          height: 8,
          "& .MuiLinearProgress-bar": {
            transition: "transform .1s linear",
          },
        },
      },
    },
    FeatureToggleChipTabBar: {
      styleOverrides: {
        root: {
          "&>.MuiTabs-flexContainer": {
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(1.25),
          },
        },
        tab: {
          display: "flex",
          flexDirection: "row",
          padding: theme.spacing(1.5, 3),
          borderRadius: "16px",
          boxShadow: "none",
          background: theme.palette.common.white,
          border: `1px solid ${theme.palette.grey[200]}`,
          whiteSpace: "nowrap",
          height: "48px",
          gap: theme.spacing(2),
          minHeight: "48px",
          color: theme.palette.text.primary,
          fontWeight: 400,
          fontSize: "1rem",
          letterSpacing: "0.00938em",
          "&.Mui-selected": {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "&>.MuiSvgIcon-root": {
              fill: theme.palette.primary.contrastText,
            },
          },
          "&>.MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            fill: theme.palette.primary.main,
            marginLeft: theme.spacing(0.5),
            marginRight: "-6px",
          },
          ":hover:not(.Mui-selected)": {
            background: theme.palette.primary.light,
          },
        },
      },
    },
    SidebarMenu: {
      styleOverrides: {
        root: {
          height: "100%",
          maxHeight: "1000px",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2.5),
          transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.shortest}ms`,
        },
        headerContainer: {
          padding: theme.spacing(3),
          justifyContent: "center",
        },
        headerLogo: {},
        navigationContainer: {
          flex: 1,
          maxHeight: "790px",
        },
        toolbarContainer: {
          display: "flex",
          padding: theme.spacing(1.5, 2),
          gap: theme.spacing(2),
        },
        languageButton: {
          display: "none",
        },
        searchButton: {
          width: "260px",
          maxwidth: "260px",
          borderRadius: "16px",
          border: `1px solid ${theme.palette.divider}`,
        },
        languageSelectMenu: {
          height: "100%",
          width: "95px",
          borderRadius: "16px",
        },
      },
    },
    LanguageSelectMenu: {
      defaultProps: {
        MenuProps: {
          anchorOrigin: { horizontal: "center", vertical: "top" },
          transformOrigin: { horizontal: "center", vertical: "bottom" },
        },
      },
      styleOverrides: {
        root: {
          "& .MuiSelect-select.MuiInputBase-input": {
            color: theme.palette.text.secondary,
            fontSize: "1.25rem",
            padding: theme.spacing(2, 4, 1.5, 3),
          },
        },
        menuItem: {
          fontSize: "1.125rem",
        },
      },
    },
    ServicePage: {
      styleOverrides: {
        pageCard: {
          overflow: "hidden",
        },
        pageCardContent: {
          padding: 0,
          overflow: "hidden auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        gridContainer: {
          width: "100%",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: theme.spacing(2.5),
          padding: theme.spacing(2, 8),
          justifyItems: "center",
        },
        gridItem: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: theme.spacing(2.5),
          overflow: "auto",
        },
        emptyDataContainer: {
          height: "960px",
          marginTop: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        venueSelector: {
          display: "none",
        },
      },
    },
    ServiceCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "24px",
          overflow: "hidden",
          border: `0.4px solid ${theme.palette.divider}`,
          "&:first-of-type": {
            borderRadius: "32px",
          },
          "&:last-of-type": {
            borderRadius: "32px",
          },
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: 0,
          },
        },
        accordionSummary: {
          height: "168px",
          padding: theme.spacing(4, 3),
          gap: theme.spacing(3),
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          ":after": {
            content: "''",
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 0,
            background: `linear-gradient(89deg, ${alpha(
              theme.palette.background.paper,
              0.9
            )} 49.87%, ${alpha(theme.palette.background.paper, 0)} 92.75%)`,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: theme.palette.text.primary,
            "& .MuiSvgIcon-root": {
              width: "32px",
              height: "32px",
            },
          },
        },
        coverImage: {
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          backgroundColor: alpha(theme.palette.background.paper, 0.8),
          backgroundBlendMode: "lighten",
          backgroundSize: "cover",
          filter: "grayscale(100%)",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          width: "60%",
        },
        summaryContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(4),
          alignItems: "center",
          zIndex: 1,
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          fontSize: "1.5rem",
          fontWeight: 700,
          color: theme.palette.text.primary,
          lineHeight: 1.3,
        },
        descriptionText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 3,
          overflow: "hidden",
          wordBreak: "break-word",
          color: theme.palette.text.secondary,
          fontSize: "1.25rem",
          lineHeight: 1.3,
        },
        serviceIconContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "64px",
          height: "64px",
          background: theme.palette.grey[200],
        },
        serviceIcon: {
          color: theme.palette.text.secondary,
          width: "40px",
          height: "40px",
        },
        infoContainer: {},
        accordionDetails: {
          padding: theme.spacing(1),
          backgroundColor: theme.palette.primary.contrastText,
        },
        locationList: {
          padding: theme.spacing(0, 3),
          overflow: "hidden auto",
          maxHeight: "280px",
          "::-webkit-scrollbar": {
            width: "4px",
          },
          "::-webkit-scrollbar-track": {
            background: theme.palette.grey[200],
          },
          "::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
          },
        },
        locationListItem: {
          display: "flex",
          minHeight: "48px",
          borderBottom: `solid 1px ${theme.palette.divider}`,
          padding: theme.spacing(1, 0),
          "&:last-of-type": {
            borderBottom: "none",
          },
        },
        locationNavigateButton: {
          color: theme.palette.text.primary,
          marginRight: theme.spacing(-3),
          "& .MuiSvgIcon-root": {
            width: "32px",
            height: "32px",
          },
        },
        floorTextAvatar: {
          width: "32px",
          height: "32px",
          color: theme.palette.text.secondary,
          minWidth: "32px",
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.25rem",
          display: "flex",
          marginLeft: theme.spacing(2),
          lineHeight: 1.3,
        },
        venueLogo: {
          maxHeight: "30px",
          maxWidth: "60px",
          objectFit: "contain",
        },
        venueLogoWrapper: {
          width: "92px",
          height: "32px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        divider: {
          borderColor: theme.palette.divider,
        },
        listNameText: {
          fontSize: "1.25rem",
          lineHeight: 1.3,
          color: theme.palette.text.secondary,
        },
        serviceLabel: {
          display: "none",
        },
      },
    },
    VuiFilterVenueRadioButtons: {
      styleOverrides: {
        root: {
          display: "none",
        },
      },
    },
    PlaceDetailSideBar: {
      defaultProps: {
        operationTimeOption: {
          multiline: false,
        },
      },
      styleOverrides: {
        root: {
          height: "100%",
        },
        headerContainer: {
          display: "flex",
          paddingTop: 0,
          width: "100%",
          gap: theme.spacing(2),
        },
        contentContainer: {
          padding: theme.spacing(4),
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        descriptionContainer: {
          height: "210px",
          position: "relative",
          lineHeight: 1.4,
          marginTop: theme.spacing(4),
          "&:before": {
            content: "''",
            position: "absolute",
            bottom: 0,
            right: 0,
            width: "100%",
            height: 50,
            background: `linear-gradient(180deg, transparent 10%, ${theme.palette.background.paper} 90%)`,
          },
        },
        descriptionText: {
          maxHeight: "100%",
          fontSize: "1rem",
          lineHeight: 1.3,
          marginBottom: 0,
          color: theme.palette.text.secondary,
          overflowY: "scroll",
          scrollbarWidth: "none",
          paddingBottom: theme.spacing(8),
        },
        titleText: {
          fontSize: "1.725rem",
          color: theme.palette.text.primary,
          lineHeight: 1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          fontWeight: 600,
          paddingRight: theme.spacing(10),
        },
        venueNameText: {
          display: "none",
          color: theme.palette.text.secondary,
        },
        avatarContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          width: "98px",
        },
        avatarRoot: {
          background: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          border: `1px solid ${theme.palette.divider}`,
          margin: 0,
          height: 98,
          width: 98,
          borderRadius: "12px",
          "& .MuiSvgIcon-root": {
            width: 48,
            height: 48,
          },
        },
        venueLogoStyle: {
          display: "none",
        },
        sidebarContent: {
          background: theme.palette.background.paper,
        },
        infoListContainer: {
          display: "flex",
          justifyContent: "space-between",
          gap: theme.spacing(3.75),
          width: "100%",
        },
        infoListItem: {
          display: "flex",
          gap: theme.spacing(1),
          "& path": {
            fill: theme.palette.grey[800],
          },
          "&:nth-of-type(2)": {
            "& .VuiDescriptionList-contentText": {
              width: "100%",
              WebkitLineClamp: 2,
              textWrap: "wrap",
              wordBreak: "break-word",
            },
          },
          "&.is-coming-soon": {
            "& > *,& .VuiDescriptionList-root > *": {
              color: theme.palette.error.main,
            },
          },
        },
        infoLabel: {
          alignItems: "start",
          "& .VuiDescriptionList-labelText": {
            fontSize: "0.825rem",
            fontWeight: 400,
            lineHeight: "120%",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            textWrap: "nowrap",
            textTransform: "capitalize",
          },
          "& .VuiDescriptionList-contentText": {
            color: "#494656",
            fontSize: "1rem",
            fontWeight: 700,
            lineHeight: "128%",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            textWrap: "nowrap",
          },
        },
        openingLabel: {},
        qrCode: {
          width: "102px",
          height: "102px",
          padding: 0,
          "&:before": {
            display: "none",
          },
          "&:after": {
            display: "none",
          },
          "& .AppQRCode-content": {
            height: "100%",
            width: "100%",
            ":before": {
              display: "none",
            },
            ":after": {
              display: "none",
            },
          },
        },
        qrCodeCaptionContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "center",
        },
        qrCodePrimaryText: {
          fontSize: "1.2rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: theme.palette.text.primary,
          textAlign: "center",
        },
        qrCodeSecondaryText: {
          lineHeight: "1.2",
          fontSize: "1rem",
          color: theme.palette.text.primary,
          textAlign: "center",
          fontWeight: 500,
        },
        closeButton: {
          position: "absolute",
          top: "12px",
          right: "12px",
          padding: 0,
          width: "82px",
          height: "82px",
          borderRadius: "24px",
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
            color: theme.palette.text.primary,
          },
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        infoContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(5),
          marginTop: theme.spacing(4),
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.5),
          marginTop: theme.spacing(1.5),
        },
        actionButton: {
          flex: 1,
          height: "80px",
          width: "100%",
          fontSize: "1.44rem",
          borderRadius: "24px",
          textTransform: "capitalize",
        },
        galleryCarouselWrapper: {
          position: "relative",
          marginTop: "auto",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "65px",
            height: "220px",
            background:
              "linear-gradient(-90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 1) 20%, rgba(256, 256, 256, 0) 100%)",
            right: -30,
            zIndex: 1,
          },
          '[dir="rtl"] &:before': {
            background:
              "linear-gradient(90deg, rgba(256, 256, 256, 1) 0%, rgba(256, 256, 256, 0) 80%, rgba(256, 256, 256, 0) 100%)",
          },
        },
        galleryCarousel: {
          position: "static",
          width: "480px",
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
          "& .splide__arrow": {
            margin: theme.spacing(0),
            width: "32px",
            height: "32px",
            borderRadius: "8px",
            background: theme.palette.background.default,
            opacity: 1,
            transition: "opacity 0.15s ease-in-out",
            "&:disabled": {
              opacity: 0,
              pointerEvents: "none",
            },
          },
        },
        galleryCarouselItem: {
          width: "330px !important",
          borderRadius: "4px",
        },
        galleryImage: {
          aspectRatio: "3 / 2",
          borderRadius: "4px",
        },
        newShopChip: {
          display: "none",
        },
        comingSoonChip: {
          display: "none",
        },
        galleryCarouselModal: {
          "&.PlaceDetailSideBar-galleryCarouselModal": {
            "& .AppImageCarouselModal-image": {
              width: "880px",
              height: "587px",
            },
            "& .AppImageCarouselModal-carouselItem": {
              maxWidth: "914px",
            },
          },
        },
        qrCodeContainer: {
          display: "flex",
          backgroundColor: theme.palette.background.paper,
          gap: theme.spacing(2),
          height: "126px",
          padding: theme.spacing(1.5),
          marginTop: theme.spacing(5),
          "&:not(.has-gallery)": {
            marginTop: "auto",
          },
        },
        headerContentWrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        },
        promotionButton: {
          color: theme.palette.text.primary,
          borderColor: theme.palette.grey[200],
        },
      },
    },
    // NewShop and Coming will add style in next pr
    NewShopChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1.5),
          width: "fit-content",
          height: "32px",
          borderRadius: "24px",
          backgroundColor: theme.palette.error.main,
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "1rem",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    ComingSoonChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1.5),
          width: "fit-content",
          height: "32px",
          borderRadius: "24px",
          backgroundColor: theme.palette.warning.secondary,
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "1rem",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    HighlightChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1.5),
          width: "fit-content",
          height: "32px",
          borderRadius: "24px",
          backgroundColor: "#FF0000",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "1rem",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    HomeActionButton: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "300px",
          width: "300px",
          padding: theme.spacing(2),
          background: theme.palette.primary.main,
          alignItems: "center",
          justifyContent: "center",
          transformOrigin: "center",
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut,
          }),
          animation: "breatheScale 2s infinite ease-in-out",
          "@keyframes breatheScale": {
            "0%": { transform: "scale(1)" },
            "33.33%": { transform: "scale(0.95)" },
            "66.66%": { transform: "scale(1)" },
            "100%": { transform: "scale(1)" },
          },
          "&.Mui-selected": {
            borderRadius: "50%",
            background: `radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.20) 86.06%, rgba(246, 128, 198, 0.20) 100%), ${theme.palette.primary.main}`,
            "& .HomeActionButton-primaryText": {
              border: "none",
            },
            "& .HomeActionButton-primaryText, & .HomeActionButton-secondaryText":
              {
                color: theme.palette.primary.contrastText,
              },
            "& .MuiSvgIcon-root": {
              color: theme.palette.primary.contrastText,
            },
          },
        },
        textContainer: {
          display: "flex",
          flexDirection: "column-reverse",
          textTransform: "capitalize",
        },
        primaryText: {
          fontSize: "1.5rem",
          fontWeight: 700,
          lineHeight: "1.5",
        },
        secondaryText: {
          fontSize: "1.875rem",
          fontWeight: 700,
          lineHeight: "1.5",
        },
        icon: {
          "& .MuiSvgIcon-root": {
            width: "72px",
            height: "72px",
          },
        },
      },
    },
    VerticalDirectoryOccupantCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          width: "180px",
          height: "272px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "12px",
          position: "relative",
          padding: theme.spacing(1.5, 1.5, 1, 1.5),
          boxShadow: "none",
        },
        occupantLogo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "none",
          "& .MuiAvatar-root": {
            borderRadius: 0,
            width: "156px",
            height: "156px",
            "& .MuiSvgIcon-root": {
              width: "56px",
              height: "56px",
            },
          },
          "& .MuiAvatar-img": {
            objectFit: "contain",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: 0,
          marginTop: theme.spacing(1),
          height: "100%",
          width: "100%",
          maxWidth: "125px",
          "& .MuiTypography-root": {
            lineHeight: 1.4,
          },
        },
        levelAvatar: {
          position: "absolute",
          bottom: 10,
          right: 10,
          width: 28,
          height: 28,
          fontSize: "0.75rem",
          color: theme.palette.primary.main,
          backgroundColor: alpha(theme.palette.primary.main, 0.2),
          borderRadius: "4px",
          fontWeight: 700,
        },
        venueLogo: {
          display: "none",
        },
        titleText: {
          fontSize: "1rem",
          fontWeight: 700,
          flexGrow: 1,
          color: theme.palette.text.primary,
          height: "45px",
          maxHeight: "45px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
        detailWrapper: {
          display: "flex",
          flexDirection: "column",
        },
        infoContainer: {
          display: "flex",
        },
        categoryText: {
          fontSize: "0.75rem",
          color: theme.palette.text.secondary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
          paddingTop: theme.spacing(1),
        },
        boothText: {
          display: "none",
        },
        chipContainer: {
          position: "absolute",
          display: "flex",
          justifyContent: "space-between",
          top: 16,
          zIndex: 2,
          width: "100%",
          padding: theme.spacing(0, 2),
        },
        adsChip: {
          padding: theme.spacing(1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: alpha(theme.palette.grey[800], 0.6),
          marginLeft: "auto",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 700,
            color: theme.palette.grey[200],
          },
        },
        newShopChip: {
          display: "none",
        },
        comingSoonChip: {
          display: "none",
        },
      },
    },
    VerticalDirectorySkeletonCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          borderRadius: "8px",
          boxShadow: "none",
          width: "180px",
          height: "272px",
          padding: theme.spacing(1.5, 1.5, 1, 1.5),
          border: `1px solid ${theme.palette.divider}`,
          background: theme.palette.background.paper,
        },
        avatar: {
          boxShadow: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 156px",
          width: "156px",
          height: "156px",
        },
        logo: {
          display: "none",
        },
        cardContent: {
          padding: 0,
        },
        divider: {
          display: "none",
        },
      },
    },
    DetailPage: {
      defaultProps: {
        galleryCarouselOption: {},
        galleryModalCarouselOption: {
          rewind: false,
        },
      },
      styleOverrides: {
        pageCardContent: {
          display: "grid",
          // replace `612px` with event/promotion gallery width
          gridTemplateColumns: "612px 1fr",
          gridTemplateRows: "1fr 80px",
          gridTemplateAreas: "'media detail' 'media button'",
          gap: theme.spacing(3, 5),
          padding: theme.spacing(3, 8),
        },
        carouselContainer: {
          gridArea: "media",
          display: "flex",
          flexDirection: "column",
          width: "100%",
        },
        carousel: {
          borderRadius: "20px",
          "& .splide__pagination": {
            paddingTop: theme.spacing(1.5),
          },
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            width: "20px",
            height: "20px",
            backgroundColor: theme.palette.primary.main,
            borderRadius: 30,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut} `,
            transform: "none",
          },
          "& .splide__track": {
            borderRadius: "20px",
            margin: 0,
            padding: theme.spacing(0, 3.75),
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "scale(1)",
              opacity: 1,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "scale(1)",
              },
            },
          },
        },
        carouselCard: {
          height: "100%",
          aspectRatio: theme.mixins?.cardRatio?.aspectRatio,
          objectFit: "cover",
        },
        cardHeader: {
          overflow: "hidden",
          padding: theme.spacing(3, 0, 0, 0),
          "& .MuiCardHeader-title": {
            color: theme.palette.text.primary,
            fontSize: "1.725rem",
            fontWeight: 700,
            lineHeight: "112%",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            maxWidth: "fit-content",
            wordBreak: "break-word",
          },
        },
        qrCodeContainer: {
          height: "116px",
          display: "flex",
          marginTop: "auto",
        },
        qrCode: {
          width: 116,
          height: "auto",
          padding: 0,
          "&:before": {
            display: "none",
          },
          "&:after": {
            display: "none",
          },
          "& .AppQRCode-content": {
            width: "100%",
            height: "auto",
            padding: theme.spacing(2),
            ":last-child": {
              paddingBottom: theme.spacing(2),
            },
            ":before": {
              display: "none",
            },
            ":after": {
              display: "none",
            },
          },
        },
        qrCodeTextContainer: {
          flex: 1,
          justifyContent: "center",
          backgroundColor: theme.palette.background.paper,
          gap: theme.spacing(1),
        },
        qrCodeTextPrimary: {
          color: theme.palette.text.primary,
          fontSize: "1.2rem",
          fontWeight: 600,
          lineHeight: "120%",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          paddingTop: 0,
        },
        qrCodeTextSecondary: {
          color: theme.palette.text.secondary,
          fontSize: "1.2rem",
          fontWeight: 400,
          lineHeight: "120%",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
        },
        cardContentWrapper: {
          gridArea: "detail",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          boxShadow: "none",
        },
        infoContainer: {
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.palette.background.default,
          borderRadius: "8px",
          padding: theme.spacing(2, 1),
          marginTop: theme.spacing(3),
          gap: theme.spacing(2),
          "& .MuiDivider-root": {
            margin: 0,
            height: "1px",
            borderBottom: `1px solid ${theme.palette.divider}`,
          },
        },
        infoItem: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          alignItems: "center",
          "& .InfoItem-title": {
            color: theme.palette.text.secondary,
            fontSize: "1.25rem",
            lineHeight: "120%",
          },
          "& .InfoItem-primary": {
            color: theme.palette.text.primary,
            fontSize: "1.2rem",
            fontWeight: 600,
            lineHeight: "120%",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            maxWidth: "fit-content",
            wordBreak: "break-word",
            textWrap: "nowrap",
            "& .MuiTypography-root": {
              color: theme.palette.text.primary,
              fontSize: "1.2rem",
              fontWeight: 600,
              lineHeight: "120%",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              maxWidth: "fit-content",
              wordBreak: "break-word",
              textWrap: "nowrap",
            },
          },
        },
        infoDivider: {},
        cardContentDetailHeader: {
          color: theme.palette.text.primary,
          fontSize: "1.2rem",
          fontWeight: 700,
          lineHeight: "112%",
          padding: theme.spacing(3, 0, 1.5, 0),
        },
        cardContentDetail: {
          flex: 1,
          overflow: "hidden auto",
          scrollbarWidth: "none",
          padding: 0,
          "&:before": {
            content: "''",
            position: "absolute",
            bottom: 116,
            right: 0,
            width: "100%",
            height: 100,
            background: `linear-gradient(180deg, transparent 10%, ${theme.palette.background.paper} 90%)`,
          },
        },
        cardContentDetailDescription: {
          color: theme.palette.text.secondary,
          fontSize: "1rem",
          fontWeight: 400,
          lineHeight: "140%",
          paddingBottom: theme.spacing(8),
        },
        buttonContainer: {
          gridArea: "button",

          display: "flex",
          justifyContent: "center",
          gap: theme.spacing(1.5),
        },
        buttonBack: {
          width: 220,
          borderRadius: "24px",
          border: `1px solid ${theme.palette.grey[200]}`,
          "& .MuiTypography-root": {
            color: theme.palette.text.primary,
            fontSize: "1.2rem",
            fontWeight: 400,
            lineHeight: "120%",
          },
        },
        buttonViewLocation: {
          width: 220,
          borderRadius: "24px",
          "& .MuiTypography-root": {
            color: theme.palette.common.white,
            fontSize: "1.2rem",
            fontWeight: 400,
            lineHeight: "120%",
          },
        },
        galleryCarouselModal: {
          "& .AppImageCarouselModal-carousel": {
            transform: "translateY(30px)",
          },
          "& .AppImageCarouselModal-image": {
            width: "532px",
            height: "unset",
            // TODO: will fix, it's did not override by theme
            aspectRatio: mixins.cardRatio.aspectRatio,
          },
          "& .AppImageCarouselModal-carouselItem": {
            maxWidth: "572px",
          },
          "& .AppImageCarouselModal-closeButton": {
            top: -100,
            right: 0,
            transform: "translateX(-50%)",
            zIndex: 2,
            width: "82px",
            height: "82px",
            borderRadius: "24px",
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
        },
      },
    },
    VerticalDirectionImageDialog: {
      styleOverrides: {
        root: {
          "&.VerticalDirectionImageDialog-root": {
            position: "fixed",
            zIndex: 1300,
            right: 600,
            bottom: 40,
            top: 40,
            left: 40,
          },
          "& .MuiBackdrop-root": {
            right: 600,
            bottom: 40,
            top: 40,
            left: 40,
            borderRadius: "32px",
          },
          "& .MuiPaper-elevation": {
            height: 276,
            maxWidth: 690,
            width: 600,
            borderRadius: "32px",
          },
        },
        container: {
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(4),
          padding: theme.spacing(6, 8),
        },
        image: {
          height: 180,
          width: 180,
        },
        descriptionContainer: {
          display: "flex",
          flexDirection: "column",
        },
        highlightedText: {
          fontWeight: 700,
          fontSize: "1rem",
        },
        headerContainer: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        primaryText: {
          fontSize: "2rem",
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
        secondaryText: {
          fontSize: "1rem",
        },
        arrowIcon: {
          width: "32px",
          height: "32px",
        },
      },
    },
    VuiDescriptionList: {
      styleOverrides: {
        labelText: {
          color: theme.palette.text.secondary,
        },
        contentText: {
          color: theme.palette.text.primary,
        },
      },
    },
    OrdinalSelectSplide: {
      styleOverrides: {
        listItemButton: {
          width: 48,
          height: 48,
          justifyContent: "center",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "50%",
          fontSize: "1.25rem",
          color: "#8E8C8D",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.background.paper,
            },
          },
        },
        root: {
          backgroundColor: theme.palette.primary.main,
          padding: theme.spacing(2.25, 1.5),
          borderRadius: "50px",
          width: 88,
          "& .splide": {
            maskImage:
              "linear-gradient(to bottom, transparent, black 12%, black 84%, transparent)",
          },
          "& .splide__track": {
            "& .splide__list": {
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            },
          },
          "& .splide__track--nav": {
            "& .splide__list >.splide__slide": {
              border: "none",
              "&.is-active": {
                border: "none",
              },
            },
          },
          "& .splide__slide": {
            margin: theme.spacing(0.75, 0),
            height: "48px !important",
            "&.is-visible": {
              "&> *": {
                opacity: 0.7,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
            "&.is-visible.is-prev:not(.is-dragging)": {
              height: "60px !important",
              "&> *": {
                opacity: 1,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
              "& .MuiListItemButton-root": {
                width: 60,
                height: 60,
                transition: `width ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut},height ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
            "&.is-visible.is-next:not(.is-dragging)": {
              height: "60px !important",
              "&> *": {
                opacity: 1,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
              "& .MuiListItemButton-root": {
                width: 60,
                height: 60,
                transition: `width ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut},height ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
            "&.is-visible.is-active": {
              height: "64px !important",
              "&> *": {
                opacity: 1,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
              "& .MuiListItemButton-root": {
                width: 64,
                height: 64,
                transition: `width ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut},height ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
              },
            },
            "&.is-dragging": {
              height: "48px !important",
              "&> *": {
                opacity: 1,
                transition: `opacity ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
                "& .MuiListItemButton-root": {
                  width: 48,
                  height: 48,
                  transition: `width ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut},height ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeInOut}`,
                },
              },
            },
          },
        },
      },
    },
    ScrollableTab: {
      styleOverrides: {
        root: {
          height: "auto",
        },
        scrollContainer: {
          display: "flex",
          alignItems: "flex-start",
          position: "relative",
          "& .MuiTabs-indicator": {
            display: "none",
          },
          "& .MuiTabs-scroller": {
            minHeight: 104,
          },
          "& .MuiTabs-scrollButtons": {
            display: "flex",
            zIndex: 2,
            "&.Mui-disabled": {
              opacity: 0,
              visibility: "hidden",
            },
          },
          "&:not(.MuiTabs-vertical) .MuiTabs-scrollButtons": {
            position: "absolute",
            top: "32px",
            "&:first-of-type": {
              left: 0,
            },
            "&:last-of-type": {
              right: 0,
            },
          },
          "&.MuiTabs-vertical .MuiTabs-scrollButtons": {
            transform: "rotate(90deg)",
            position: "absolute",
            "&:first-of-type": {
              top: 0,
            },
            "&:last-of-type": {
              bottom: 0,
            },
          },
        },
        iconButton: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "50%",
          fill: theme.palette.text.secondary,
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
      },
    },
    BottomSidebarAction: {
      styleOverrides: {
        root: {
          display: "flex",
          gap: theme.spacing(1.5),
          height: "110px",
          width: "100%",
          marginTop: theme.spacing(1.5),
          overflow: "hidden",
          "& .MuiButtonBase-root": {
            display: "flex",
            flexDirection: "column",
            borderRadius: "20px",
            border: `1px solid ${theme.palette.divider}`,
            gap: theme.spacing(1),
            textTransform: "capitalize",
            fontSize: "1.25rem",
            color: theme.palette.text.primary,
            background: theme.palette.background.paper,
            boxShadow:
              "0 1px 2px 0 rgba(16, 24, 40, 0.05), 0 0 0 1px rgba(16, 24, 40, 0.18) inset, 0 -2px 0 0 rgba(16, 24, 40, 0.05) inset",
            "& .MuiButton-startIcon": {
              margin: 0,
              "& svg": {
                width: "32px",
                height: "32px",
              },
            },
            "&:hover": {
              background: theme.palette.background.paper,
            },
          },
        },
        backButton: { flex: 2 },
        homeButton: { flex: 1, maxWidth: "110px" },
        searchButton: {
          flex: 1,
          maxWidth: "110px",
          justifyContent: "center",
          "& svg": {
            margin: 0,
            color: theme.palette.text.primary,
          },
          "& .MuiTypography-root": {
            fontSize: "1.25rem",
            fontWeight: 500,
            color: theme.palette.text.primary,
          },
        },
      },
    },
    HorizontalScrollBarWithButton: {
      styleOverrides: {
        root: {},
        content: {},
      },
    },
    NoStepFreeRouteModal: {
      styleOverrides: {
        root: {
          "& .MuiDialog-container": {
            "& .MuiDialog-paper": {
              margin: theme.spacing(2),
              padding: theme.spacing(3),
              gap: theme.spacing(2),
              position: "fixed",
              bottom: 16,
            },
          },
        },
        title: {
          fontSize: "1.5rem",
          fontWeight: 700,
          textAlign: "center",
          padding: theme.spacing(0, 3),
        },
        content: {
          fontSize: "0.8rem",
          color: theme.palette.text.secondary,
          padding: 0,
          textAlign: "center",
        },
        actions: {
          padding: 0,
          "& .MuiButton-root": {
            flex: 1,
          },
        },
        closeButton: {
          width: 24,
          height: 24,
          backgroundColor: theme.palette.background.default,
          borderRadius: "50%",
          position: "absolute",
          top: 12,
          right: 12,
          "& svg": {
            height: 8,
            width: 8,
          },
        },
      },
    },
  },
})
